(() => {
  const GROUP_SEQUENCE = [
    'table-range',
    'table-size',
    'table-finish',
    'chair-range',
    'chair-material',
    'chair-legs',
    'config-summary'
  ];

  let price_2 = 0;

  const FALLBACK_IMAGE = 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="160" height="120" viewBox="0 0 160 120"><rect width="160" height="120" fill="%23f2f2f2"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-family="Arial" font-size="12" fill="%23999">No image</text></svg>';

  const LEG_NONE_KEY = '__NONE__';

  const CYLINDO_MODULE_SOURCES = [
    'https://viewer-cdn.cylindo.com/v1/bar.mjs',
    'https://viewer-cdn.cylindo.com/v1/index.mjs',
    'https://viewer-cdn.cylindo.com/v1/shopify.mjs'
  ];
  const CYLINDO_PRECONNECT = 'https://content.cylindo.com';
  let cylindoModulePromise = null;

  const DEFAULT_THUMBNAIL_FRAMES = [6, 17, 3, 1, 32, 13];
  const DEFAULT_CYLINDO_ACCOUNT_ID = '6913';
  const DEFAULT_FRAME_IMAGE_SIZE = 1024;
  const DEFAULT_COLOUR_FEATURE_KEYS = [
    'CHAIR UPHOLSTERY',
    'UPHOLSTERY',
    'FABRIC',
    'CHAIR FABRIC',
    'CHAIR MATERIAL',
    'CHAIR COLOUR',
    'COLOR',
    'COLOUR'
  ];

  const currencyFormatterCache = new Map();

  function ensureCylindoPreconnect() {
    if (document.querySelector(`link[rel="preconnect"][href="${CYLINDO_PRECONNECT}"]`)) {
      return;
    }
    const link = document.createElement('link');
    link.rel = 'preconnect';
    link.href = CYLINDO_PRECONNECT;
    link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
  }

  function loadCylindoModule() {
    if (window?.customElements?.get && window.customElements.get('cylindo-viewer')) {
      return Promise.resolve();
    }
    if (cylindoModulePromise) {
      return cylindoModulePromise;
    }
    ensureCylindoPreconnect();
    cylindoModulePromise = CYLINDO_MODULE_SOURCES.reduce((chain, src) => {
      return chain.then(() => import(/* webpackIgnore: true */ src));
    }, Promise.resolve()).catch(error => {
      cylindoModulePromise = null;
      throw error;
    });
    return cylindoModulePromise;
  }

  // function formatMoney(amount, currency = 'R') {
  //   const key = currency || 'R';
  //   if (!currencyFormatterCache.has(key)) {
  //     currencyFormatterCache.set(key, new Intl.NumberFormat(undefined, {
  //       style: 'currency',
  //       currency: key,
  //       minimumFractionDigits: 0,
  //       maximumFractionDigits: 2
  //     }));
  //   }
  //   const formatter = currencyFormatterCache.get(key);
  //   return formatter.format(typeof amount === 'number' ? amount : 0);
  // }

  //   function formatMoney(amount, currency = 'ZAR') {
  //   const key = currency || 'ZAR';

  //   if (!currencyFormatterCache.has(key)) {
  //     currencyFormatterCache.set(
  //       key,
  //       new Intl.NumberFormat(undefined, {
  //         style: 'currency',
  //         currency: key,
  //         currencyDisplay: 'narrowSymbol', // This makes "ZAR" display as "R"
  //         minimumFractionDigits: 0,
  //         maximumFractionDigits: 2,
  //       })
  //     );
  //   }

  //   const formatter = currencyFormatterCache.get(key);
  //   return formatter.format(typeof amount === 'number' ? amount : 0);
  // }


  function formatMoney(amount, currency = 'ZAR') {
    // Normalize incorrect currencies
    if (currency === 'R' || currency === '' || currency == null) {
      currency = 'ZAR';
    }

    const key = currency;

    if (!currencyFormatterCache.has(key)) {
      currencyFormatterCache.set(
        key,
        new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: 'ZAR',
          currencyDisplay: 'narrowSymbol', // Shows "R"
          minimumFractionDigits: 0,
          maximumFractionDigits: 2
        })
      );
    }

    const formatter = currencyFormatterCache.get(key);
    return formatter.format(typeof amount === 'number' ? amount : 0);
  }



  function createElement(tag, options = {}) {
    const el = document.createElement(tag);
    if (options.className) {
      el.className = options.className;
    }
    if (options.attrs) {
      Object.entries(options.attrs).forEach(([key, value]) => {
        if (value === undefined || value === null) {
          return;
        }
        el.setAttribute(key, value);
      });
    }
    if (options.text) {
      el.textContent = options.text;
    }
    if (options.html) {
      el.innerHTML = options.html;
    }
    return el;
  }

  function uniqueBy(arr, key) {
    const seen = new Set();
    return arr.filter(item => {
      const value = typeof key === 'function' ? key(item) : item[key];
      if (seen.has(value)) {
        return false;
      }
      seen.add(value);
      return true;
    });
  }

  function parseFrameList(value) {
    if (!value && value !== 0) return [];
    let raw = null;
    if (Array.isArray(value)) {
      raw = value;
    } else if (typeof value === 'number') {
      raw = [value];
    } else if (typeof value === 'string') {
      const trimmed = value.trim();
      if (!trimmed) {
        raw = [];
      } else {
        if ((trimmed.startsWith('[') && trimmed.endsWith(']')) || (trimmed.startsWith('{') && trimmed.endsWith('}'))) {
          try {
            const parsed = JSON.parse(trimmed);
            if (Array.isArray(parsed)) {
              raw = parsed;
            } else if (parsed && Array.isArray(parsed.frames)) {
              raw = parsed.frames;
            }
          } catch (error) {
            raw = null;
          }
        }
        if (!raw) {
          raw = trimmed.split(/[\s,;|/\\]+/);
        }
      }
    } else if (value && typeof value === 'object') {
      if (Array.isArray(value.frames)) {
        raw = value.frames;
      } else {
        raw = Object.values(value);
      }
    }

    if (!Array.isArray(raw)) return [];
    const seen = new Set();
    return raw
      .map(entry => {
        const num = parseInt(entry, 10);
        return Number.isFinite(num) ? num : null;
      })
      .filter(num => {
        if (!Number.isFinite(num)) return false;
        if (num <= 0 || num > 64) return false;
        if (seen.has(num)) return false;
        seen.add(num);
        return true;
      });
  }

  function normaliseCompareValue(value) {
    if (value === null || value === undefined) return '';
    return String(value).trim().toLowerCase();
  }

  function normaliseFeatureKey(value) {
    if (value === null || value === undefined) return '';
    return String(value).trim().toUpperCase();
  }

  const RANGE_STOP_WORDS = new Set([
    'DINING',
    'TABLE',
    'WITH',
    'RECT',
    'RECTANGULAR',
    'ROUND',
    'SQUARE',
    'OVAL',
    'EXTENSION',
    'EXTENDABLE',
    'AND',
    '&',
    'LEG',
    'LEGS'
  ]);

  function deriveRangeShortName(value) {
    const raw = (value || '').replace(/[_-]+/g, ' ').trim();
    if (!raw) return '';
    const words = raw.split(/\s+/).filter(Boolean);
    if (!words.length) return '';
    const result = [];
    for (const word of words) {
      const upper = word.toUpperCase();
      if (/\d/.test(word) || RANGE_STOP_WORDS.has(upper)) {
        break;
      }
      result.push(word);
    }
    if (!result.length) {
      result.push(words[0]);
    }
    return result
      .map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
      .join(' ');
  }

  function coerceFeatureObject(rawFeatures) {
    if (!rawFeatures && rawFeatures !== 0) return null;
    if (typeof rawFeatures === 'object' && !Array.isArray(rawFeatures)) {
      return rawFeatures;
    }
    if (typeof rawFeatures === 'string') {
      let parsed = null;
      try {
        const json = JSON.parse(rawFeatures);
        if (json && typeof json === 'object' && !Array.isArray(json)) {
          parsed = json;
        }
      } catch (error) {
        parsed = null;
      }
      if (parsed) {
        return parsed;
      }
      let featurePairs = rawFeatures;
      const questionMarkIndex = featurePairs.indexOf('?');
      if (questionMarkIndex !== -1) {
        featurePairs = featurePairs.slice(questionMarkIndex + 1);
      }
      const parts = featurePairs.split('&').map(part => part.trim()).filter(Boolean);
      if (parts.length) {
        const result = {};
        parts.forEach(part => {
          const [rawKey, rawVal] = part.split('=');
          if (!rawKey) return;
          const decodedKey = decodeURIComponent(rawKey).trim();
          const decodedValue = decodeURIComponent(rawVal || '').trim();
          if (decodedKey) {
            result[decodedKey] = decodedValue;
          }
        });
        return Object.keys(result).length ? result : null;
      }
    }
    return null;
  }

  function normaliseCylindoFeatureMap(rawFeatures) {
    const source = coerceFeatureObject(rawFeatures);
    if (!source || typeof source !== 'object') {
      return null;
    }
    const normalised = {};
    Object.entries(source).forEach(([key, value]) => {
      const trimmedKey = String(key || '').trim();
      if (!trimmedKey) return;
      const trimmedValue = value === null || value === undefined ? '' : String(value).trim();
      if (!trimmedValue) return;
      normalised[trimmedKey] = trimmedValue;
    });
    return Object.keys(normalised).length ? normalised : null;
  }

  function resolveColourFeature(featuresMap, colourCode, colourDisplay) {
    if (!featuresMap || typeof featuresMap !== 'object') {
      return { feature: null, option: null };
    }
    const candidates = [colourCode, colourDisplay].map(normaliseCompareValue).filter(Boolean);
    let fallbackEntry = null;
    for (const [key, rawValue] of Object.entries(featuresMap)) {
      const normalisedValue = normaliseCompareValue(rawValue);
      if (normalisedValue && candidates.includes(normalisedValue)) {
        return {
          feature: key,
          option: typeof rawValue === 'number' ? String(rawValue) : String(rawValue || '').trim()
        };
      }
      if (!fallbackEntry && DEFAULT_COLOUR_FEATURE_KEYS.includes(normaliseFeatureKey(key))) {
        fallbackEntry = [key, rawValue];
      }
    }
    if (fallbackEntry) {
      const [key, rawValue] = fallbackEntry;
      return {
        feature: key,
        option: typeof rawValue === 'number' ? String(rawValue) : String(rawValue || '').trim()
      };
    }
    return { feature: null, option: null };
  }

  function buildCylindoMaterialUrl(accountId, productCode, featureName, optionValue, size = 256) {
    const trimmedAccount = String(accountId || '').trim();
    const trimmedProduct = String(productCode || '').trim();
    const trimmedFeature = String(featureName || '').trim();
    const trimmedOption = String(optionValue || '').trim();
    if (!trimmedAccount || !trimmedProduct || !trimmedFeature || !trimmedOption) {
      return null;
    }
    const base = `https://content.cylindo.com/api/v2/${encodeURIComponent(trimmedAccount)}`;
    const encodedProduct = encodeURIComponent(trimmedProduct);
    const params = [
      `size=${encodeURIComponent(String(size))}`,
      `feature=${encodeURIComponent(trimmedFeature)}:${encodeURIComponent(trimmedOption)}`
    ];
    return `${base}/products/${encodedProduct}/material/${encodedProduct}.webp?${params.join('&')}`;
  }

  function buildCylindoFrameUrl(accountId, productCode, frameIndex, featuresMap, options = {}) {
    const trimmedAccount = String(accountId || '').trim();
    const trimmedProduct = String(productCode || '').trim();
    if (!trimmedAccount || !trimmedProduct) {
      return null;
    }
    const frameNumber = parseInt(frameIndex, 10);
    if (!Number.isFinite(frameNumber) || frameNumber <= 0) {
      return null;
    }
    const format = String(options.format || 'png').replace(/^\./, '').trim() || 'png';
    const fileName = `${trimmedProduct}.${format}`;
    const params = [];
    const size = options.size ?? DEFAULT_FRAME_IMAGE_SIZE;
    const version = options.version ?? 2;
    params.push(`size=${encodeURIComponent(String(size))}`);
    if (version != null) {
      params.push(`version=${encodeURIComponent(String(version))}`);
    }
    if (featuresMap && typeof featuresMap === 'object') {
      Object.entries(featuresMap).forEach(([key, value]) => {
        const featureKey = String(key || '').trim();
        if (!featureKey) return;
        const featureValue = String(value ?? '').trim();
        if (!featureValue) return;
        params.push(`feature=${encodeURIComponent(featureKey)}:${encodeURIComponent(featureValue)}`);
      });
    }
    const base = options.baseUrl?.trim() || 'https://content.cylindo.com/api/v2';
    const queryString = params.join('&');
    return `${base}/${encodeURIComponent(trimmedAccount)}/products/${encodeURIComponent(trimmedProduct)}/frames/${encodeURIComponent(frameNumber)}/${encodeURIComponent(fileName)}?${queryString}`;
  }

  const imagePreloadCache = new Map();

  function preloadImage(url) {
    const trimmed = typeof url === 'string' ? url.trim() : '';
    if (!trimmed) {
      return Promise.resolve();
    }
    if (imagePreloadCache.has(trimmed)) {
      return imagePreloadCache.get(trimmed);
    }
    const promise = new Promise(resolve => {
      const image = new Image();
      const cleanup = () => {
        image.removeEventListener('load', handleComplete);
        image.removeEventListener('error', handleComplete);
      };
      const handleComplete = () => {
        cleanup();
        resolve(trimmed);
      };
      image.addEventListener('load', handleComplete);
      image.addEventListener('error', handleComplete);
      image.src = trimmed;
      if (image.complete) {
        handleComplete();
      }
    });
    imagePreloadCache.set(trimmed, promise);
    return promise;
  }

  function normaliseVariantId(value) {
    if (value === null || value === undefined) {
      return null;
    }
    const str = String(value).trim();
    return str ? str : null;
  }

  function normaliseNumber(value) {
    if (value === null || value === undefined) {
      return null;
    }
    if (typeof value === 'number') {
      return Number.isFinite(value) ? value : null;
    }
    const parsed = parseInt(String(value).replace(/[^0-9-]/g, ''), 10);
    return Number.isFinite(parsed) ? parsed : null;
  }

  function normaliseData(raw) {
    const config = raw?.data?.setBuilderConfig?.[0];
    if (!config) {
      return null;
    }

    const tableRangesMeta = Array.isArray(config.tables?.ranges) ? config.tables.ranges : [];
    const chairRangesMeta = Array.isArray(config.chairs?.ranges) ? config.chairs.ranges : [];
    const lookup = Array.isArray(config.lookup) ? config.lookup : [];

    const tableMetaMap = new Map();
    tableRangesMeta.forEach(range => {
      if (!range?.code) {
        return;
      }
      const sizes = Array.isArray(range.sizes) ? range.sizes : [];
      const rangeDisplay = range.display || range.code;
      tableMetaMap.set(range.code, {
        code: range.code,
        display: rangeDisplay,
        shortDisplay: deriveRangeShortName(rangeDisplay),
        imageUrl: range.imageUrl,
        sizes: sizes.map(size => ({
          code: size.code,
          display: size.display || size.code,
          numberOfChairs: size.numberOfChairs || null,
          finishes: Array.isArray(size.finishes) ? size.finishes.map(finish => ({
            code: finish.code,
            display: finish.display || finish.code
          })).filter(Boolean) : []
        }))
      });
    });

 

    const chairMetaMap = new Map();
    chairRangesMeta.forEach(range => {
      if (!range?.code) {
        return;
      }
      const materials = Array.isArray(range.materials) ? range.materials : [];
      chairMetaMap.set(range.code, {
        code: range.code,
        display: range.display || range.code,
        imageUrl: range.imageUrl,
        materials: materials.map(material => ({
          code: material.code,
          display: material.display || material.code,
          colours: Array.isArray(material.colours) ? material.colours.map(colour => ({
            code: colour.code,
            display: colour.display || colour.code,
            metaobjectId: colour.metaobjectId,
            imageUrl: colour.imageUrl,
            legs: Array.isArray(colour.legs) ? colour.legs.map(leg => ({
              code: leg.code,
              display: leg.display || leg.code,
              metaobjectId: leg.metaobjectId
            })).filter(leg => leg.code) : null
          })).filter(colour => colour.code) : []
        })).filter(material => material.code)
      });
    });

    const combos = lookup
      .map(entry => {
        const tableRangeCode = entry?.table?.range;
        const tableMeta = tableMetaMap.get(tableRangeCode);
        const tableSizeCode = entry?.table?.size;
        const tableSizeMeta = tableMeta?.sizes?.find(item => item.code === tableSizeCode);
        const tableFinishCode = entry?.table?.finish;
        const tableFinishMeta = tableSizeMeta?.finishes?.find(item => item.code === tableFinishCode);

        const chairRangeCode = entry?.chair?.range;
        const chairMeta = chairMetaMap.get(chairRangeCode);
        const chairMaterialCode = entry?.chair?.material;
        const chairMaterialMeta = chairMeta?.materials?.find(item => item.code === chairMaterialCode);
        const chairColourCode = entry?.chair?.colour;
        const chairColourMeta = chairMaterialMeta?.colours?.find(item => item.code === chairColourCode);
        const chairLegCode = entry?.chair?.leg ?? LEG_NONE_KEY;
        const chairLegMeta = Array.isArray(chairColourMeta?.legs) ? chairColourMeta.legs.find(item => item.code === entry?.chair?.leg) : null;
        const featuresObject = normaliseCylindoFeatureMap(entry?.combo?.cylindoFeaturesJson);
        const { feature: colourFeatureName, option: colourOptionValue } = resolveColourFeature(
          featuresObject,
          chairColourCode,
          chairColourMeta?.display
        );

        const rawCoriguardPrice = entry?.chair?.priceCoriguard ?? entry?.combo?.priceCoriguard ?? null;
        const parsedCoriguardPrice = rawCoriguardPrice != null ? Number(rawCoriguardPrice) : null;
        const coriguardPrice = Number.isFinite(parsedCoriguardPrice) ? parsedCoriguardPrice : null;
        //const coriguardVariantId = normaliseVariantId(entry?.chair?.CoriguardVarientID ?? entry?.combo?.CoriguardVarientID);
        const coriguardVariantId = normaliseVariantId(entry?.chair?.coriguardVariantId ?? entry?.combo?.coriguardVariantId);

        return {
          table: {
            range: tableRangeCode,
            rangeDisplay: tableMeta?.display || tableRangeCode,
            rangeShortDisplay: tableMeta?.shortDisplay || deriveRangeShortName(tableMeta?.display || tableRangeCode),
            rangeImage: tableMeta?.imageUrl,
            size: tableSizeCode,
            sizeDisplay: tableSizeMeta?.display || tableSizeCode,
            numberOfChairs: normaliseNumber(tableSizeMeta?.numberOfChairs ?? entry?.combo?.numberOfChairs),
            finish: tableFinishCode,
            finishDisplay: tableFinishMeta?.display || tableFinishCode,
            variantId: normaliseVariantId(entry?.table?.variantId),
            dimensions: entry?.table?.dimensions,
            description: entry?.table?.description
          },
          chair: {
            range: chairRangeCode,
            rangeDisplay: chairMeta?.display || chairRangeCode,
            rangeImage: chairMeta?.imageUrl,
            material: chairMaterialCode,
            materialDisplay: chairMaterialMeta?.display || chairMaterialCode,
            colour: chairColourCode,
            colourDisplay: chairColourMeta?.display || chairColourCode,
            colourImage: chairColourMeta?.imageUrl,
            colourFeature: colourFeatureName,
            colourOption: colourOptionValue,
            leg: chairLegCode,
            legDisplay: chairLegMeta?.display || entry?.chair?.legDisplay ||  entry?.chair?.leg || 'Standard leg',
            variantId: normaliseVariantId(entry?.chair?.variantId),
            coriguardVariantId,
            priceCoriguard: coriguardPrice,
            dimensions: entry?.chair?.dimensions,
            description: entry?.chair?.description
          },
          combo: {
            priceDefault: entry?.combo?.priceDefault ?? null,
            pricePromo: entry?.combo?.pricePromo ?? null,
            priceCoriguard: coriguardPrice,
            leadTime: entry?.combo?.leadTime ?? null,
            numberOfChairs: normaliseNumber(entry?.combo?.numberOfChairs ?? tableSizeMeta?.numberOfChairs),
            cylindoProductCode: entry?.combo?.cylindoProductCode || null,
            cylindoFeaturesJson: entry?.combo?.cylindoFeaturesJson || null,
            features: featuresObject
          }
        };
      })
      .filter(combo => combo.table.range && combo.table.size && combo.table.finish && combo.chair.range && combo.chair.material && combo.chair.colour);

    return {
      tables: tableMetaMap,
      chairs: chairMetaMap,
      combos
    };
  }

  function normaliseMaterialCode(value) {
    return String(value || '').trim().toUpperCase();
  }

  function normaliseMaterialLibrary(raw) {
    if (!Array.isArray(raw)) {
      return new Map();
    }

    const library = new Map();

    raw.forEach(entry => {
      const node = entry?.node || entry;
      const fieldsArray = Array.isArray(node?.fields) ? node.fields : [];
      if (!node || !fieldsArray.length) {
        return;
      }

      const fields = {};
      fieldsArray.forEach(field => {
        const key = String(field?.key || '').trim();
        if (!key) {
          return;
        }
        let value = field?.value;
        if (value === null || value === undefined) {
          const imageUrl = field?.reference?.image?.url;
          if (imageUrl) {
            value = imageUrl;
          }
        }
        fields[key] = value;
      });

      const code = fields.code || node.handle;
      const normalisedCode = normaliseMaterialCode(code);
      if (!normalisedCode) {
        return;
      }

      const image = fields.image || fields.thumbnail || fields.swatch || null;
      const description = fields.description || fields.label || fields.name || '';
      const material = {
        code: String(code || '').trim(),
        label: fields.label || fields.name || description || normalisedCode,
        type: fields.type || fields.material_type || '',
        description,
        finishType: fields.finish_type || '',
        grainType: fields.grain_type || '',
        technicalInfo: fields.technical_info || '',
        naturalMarkings: fields.natural_markings || fields.characteristics || '',
        careInstructions: fields.care_instructions || fields.cleaning_instructions || '',
        composition: fields.composition || '',
        weRecommend: fields.we_recommend || '',
        rubCount: fields.rub_count || '',
        image,
        deliveryTime: fields.delivery_time || fields.delivery_time_range || '',
        raw: fields
      };

      if (!material.careInstructions && fields.cleaning_instructions) {
        material.careInstructions = fields.cleaning_instructions;
      }

      library.set(normalisedCode, material);
    });

    return library;
  }

  function normaliseMaterialType(value) {
    const label = typeof value === 'string' ? value.trim() : '';
    if (!label) {
      return { key: 'other', label: 'Others' };
    }
    const key = label
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'other';
    const words = label.split(/\s+/).filter(Boolean);
    const titleCase = words.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
    let formattedLabel = titleCase || label || 'Others';
    if (formattedLabel.toLowerCase() === 'promotion') {
      formattedLabel = 'Promotions';
    }
    return {
      key,
      label: formattedLabel
    };
  }

  class TableChairConfigurator {

    constructor(root) {
      // console.log('root',root)
      this.root = root;
      this.state = {
        tableRange: null,
        tableSize: null,
        tableFinish: null,
        chairRange: null,
        chairMaterial: null,
        chairColour: null,
        chairColourName: null,
        chairLeg: null,
        quantity: parseInt(root.querySelector('[data-qty-input]')?.value || '4', 10) || 4,
        coriguardSelected: false,
        coriguardVariantId: null,
        coriguardPrice: null,
      };

      this.els = {
        groups: root.querySelector('[data-config-groups]'),
        tableRange: root.querySelector('[data-table-range]'),
        tableOptions: root.querySelector('[data-table-options]'),
        tableFinishes: root.querySelector('[data-table-finishes]'),
        chairRange: root.querySelector('[data-chair-range]'),
        materialTabs: root.querySelector('[data-material-tabs]'),
        materialFilters: root.querySelector('[data-material-categories]'),
        viewToggle: root.querySelector('[data-view-toggle]'),
        chairMaterials: root.querySelector('[data-chair-materials]'),
        chairLegs: root.querySelector('[data-chair-legs]'),
        summaryTable: root.querySelector('[data-summary-table]'),
        summaryChair: root.querySelector('[data-summary-chair]'),
        summaryColour: root.querySelector('[data-summary-colour]'),
        price: root.querySelector('[data-price]'),
        installment: root.querySelector('[data-installment]'),
        price_emi: root.querySelector('.price_emi'),
        installmentsWrapper: root.querySelector('[data-installments]'),
        productTitle: root.querySelector('[data-product-title]'),
        specTable: root.querySelector('[data-spec-table]'),
        //addtoCartPrice: root.querySelector('[data-tocart-price]'),
        addtoCartPrice: root.querySelectorAll('[data-tocart-price]'),
        specChair: root.querySelector('[data-spec-chair]'),
        specColour: root.querySelector('[data-spec-colour]'),
        specTableVariant: root.querySelector('[data-spec-table-variant]'),
        specChairVariant: root.querySelector('[data-spec-chair-variant]'),
        specChairQuantity: root.querySelector('[data-spec-chair-quantity]'),
        tableDimensions: root.querySelector('[data-table-dimensions]'),
        chairDimensions: root.querySelector('[data-chair-dimensions]'),
        care: root.querySelector('[data-care]'),
        delivery: root.querySelector('[data-delivery]'),
        viewer: root.querySelector('[data-viewer]'),
        quickSpecs: root.querySelector('[data-quick-specs]'),
        qtyMinus: root.querySelector('[data-qty-minus]'),
        qtyPlus: root.querySelector('[data-qty-plus]'),
        qtyInput: root.querySelector('[data-qty-input]'),
        coriguard: root.querySelector('[data-coriguard]'),
        coriguardCheckbox: root.querySelector('[data-coriguard-checkbox]'),
        coriguardPrice: root.querySelector('[data-coriguard-price-display]'),
        detailsColumn: root.querySelector('.halo-productView-right.productView-details'),
        //addToCart: root.querySelector('[data-add-to-cart]'),
        addToCart: root.querySelectorAll('.cori-add-to-cart'),
        status: root.querySelector('[data-status]'),
        clearSelections: root.querySelector('[data-clear-selections]'),
        progressLabel: root.querySelector('[data-progress-label]'),
        chairAmount: root.querySelector('[data-chair-amount]'),
        variantSummary: root.querySelector('[data-variant-summary]'),
        variantColour: root.querySelector('[data-variant-colour]'),
        variantSize: root.querySelector('[data-variant-size]'),
        leadTime: root.querySelectorAll('[data-lead-time]'),
        tableDimension: root.querySelector('#tabledimension'),
        tableDes: root.querySelector('#table-des'),
        chairDimension: root.querySelector('#chairdimension'),
        chairDes: root.querySelector('#chair-des'),
        planchange: root.querySelectorAll('input[name="payment_plan"]')
      };

      this.chairMaterialsLoader = null;
      this.chairMaterialLoadToken = 0;

      const currencyAttr = this.els.price?.getAttribute('data-currency');
      this.currency = currencyAttr || document.documentElement.getAttribute('data-shop-currency') || 'ZAR';
      this.cylindoCustomerId = root.getAttribute('data-cylindo-customer-id') || '';
      this.cylindoRemoteConfig = root.getAttribute('data-cylindo-remote-config') || '';
      this.materialsJsonUrl = root.getAttribute('data-materials-json-url') || '';
      this.materialLibrary = new Map();
      this.materialLibraryPromise = null;
      this.materialTooltip = null;
      this.materialTooltipContent = null;
      this.materialTooltipPattern = null;
      this.boundHideMaterialTooltip = this.hideMaterialTooltip.bind(this);

      this.materialView = 'grid';
      this.materialFilter = 'all';
      this.materialTypeOrder = [];
      this.normalized = null;
      this.currentCombo = null;
      this.isLoading = false;
      this.isSubmitting = false;
      this.hasSelectableLegs = false;
      this.viewerInstance = null;
      this.viewerListeners = [];
      this.previewImage = null;
      this.previewContext = null;
      this.previewFrame = null;
      this.pendingViewerFrame = null;
      this.progressDefaultText = this.els.progressLabel?.textContent?.trim() || 'Select Options 1 to 3';
      this.defaultQuantity = this.state.quantity;
      this.thumbnailFrames = parseFrameList(root.dataset.thumbnailFrames);
      if (!this.thumbnailFrames.length) {
        this.thumbnailFrames = [...DEFAULT_THUMBNAIL_FRAMES];
      }

      this.init();
    }

    init() {
      this.bindCollapsibles();
      this.bindQuantityControls();
      this.bindAddToCart();
      this.bindCoriguardToggle();
      this.bindViewToggle();
      this.bindClearSelections();
      this.bindPlanChange();
      this.root.addEventListener('mouseleave', this.boundHideMaterialTooltip);
      this.root.addEventListener('blur', this.boundHideMaterialTooltip, true);
      this.loadData();
    }

    bindCollapsibles() {
      if (!this.els.groups) return;
      const groups = [...this.els.groups.querySelectorAll('.config-group')];
      let count = 0;
      groups.forEach(group => {
      //var   count=0
       count++;
        const header = group.querySelector('.config-group__header');
        const body = group.querySelector('.config-group__body');
        const headerLabel = group.querySelector('.config-group__header span');
          const headerText = `${headerLabel?.textContent?.trim()}`;
         headerLabel.textContent = `(${count}) ${headerText}`
        if (!header || !body) return;
        const groupName = group.getAttribute('data-group');
        const isInitiallyOpen = group.classList.contains('is-open');
        header.setAttribute('aria-expanded', String(isInitiallyOpen));
        body.hidden = !isInitiallyOpen;
        header.addEventListener('click', () => {
          const shouldOpen = !group.classList.contains('is-open');
          this.toggleGroup(groupName, shouldOpen);
        });
        
      });
     
      this.toggleGroup('table-range', true);
    }

    toggleGroup(name, forceOpen) {
      if (!name || !this.els.groups) return;
      const group = this.els.groups.querySelector(`[data-group="${name}"]`);
      if (!group) return;
      const header = group.querySelector('.config-group__header');
      const body = group.querySelector('.config-group__body');
      if (!header || !body) return;
      const isOpen = forceOpen ?? !group.classList.contains('is-open');
      group.classList.toggle('is-open', isOpen);
      header.setAttribute('aria-expanded', String(isOpen));
      body.hidden = !isOpen;
      if (isOpen) {
        this.updateSelectionProgress(name);
      }
    }

    focusNextGroup(currentName) {
      const index = GROUP_SEQUENCE.indexOf(currentName);
      if (index === -1) return;
      const nextGroupName = GROUP_SEQUENCE[index + 1];
      if (!nextGroupName) return;
      this.toggleGroup(nextGroupName, true);
    }

    bindQuantityControls() {
      if (this.els.qtyMinus) {
        this.els.qtyMinus.addEventListener('click', () => {
          this.adjustQuantity(-1);
        });
      }
      if (this.els.qtyPlus) {
        this.els.qtyPlus.addEventListener('click', () => {
          this.adjustQuantity(1);
        });
      }
      if (this.els.qtyInput) {
        this.els.qtyInput.addEventListener('change', () => {
          const value = parseInt(this.els.qtyInput.value, 10);
          if (Number.isFinite(value) && value > 0) {
            this.state.quantity = value;
          } else {
            this.state.quantity = 1;
            this.els.qtyInput.value = '1';
          }
          this.updateSummary();
        });
      }
    }

    adjustQuantity(delta) {
      const next = Math.max(1, this.state.quantity + delta);
      this.state.quantity = next;
      if (this.els.qtyInput) {
        this.els.qtyInput.value = String(next);
      }
      this.updateSummary();
    }
    bindAddToCart() {
      if (!this.els.addToCart) return;

      this.els.addToCart.forEach((btn) => {
        btn.addEventListener('click', () => {
          this.handleAddToCart();
        });
      });
    }

    // bindAddToCart() {
    //   if (!this.els.addToCart) return;
    //   this.els.addToCart.addEventListener('click', () => {
    //     this.handleAddToCart();
    //   });
    // }
    bindPlanChange() {
      if (!this.els.planchange) return;
      this.els.planchange.forEach(radio => {
        radio.addEventListener('change', () => {
          const selected = this.root.querySelector('input[name="payment_plan"]:checked');
          const months = Number(selected.value)
          const installment = price_2 / months;
          this.els.installment.textContent = formatMoney(installment, this.currency);
          this.els.price_emi.textContent = formatMoney(installment, this.currency);
        });
      });

    }

    bindCoriguardToggle() {
      if (!this.els.coriguardCheckbox) return;
      this.els.coriguardCheckbox.addEventListener('change', () => {
        const isChecked = this.els.coriguardCheckbox.checked;
        this.state.coriguardSelected = isChecked;
        this.updatePrice();
      });
    }

    bindClearSelections() {
      if (!this.els.clearSelections) return;
      this.els.clearSelections.addEventListener('click', () => {
        this.resetConfigurator();
      });
    }

    bindViewToggle() {
      if (!this.els.viewToggle) return;
      this.els.viewToggle.addEventListener('click', event => {
        const target = event.target.closest('button[data-view]');
        if (!target) return;
        this.materialView = target.getAttribute('data-view');
        [...this.els.viewToggle.querySelectorAll('button[data-view]')].forEach(button => {
          const isActive = button === target;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', String(isActive));
        });
        if (this.els.chairMaterials) {
          this.els.chairMaterials.setAttribute('data-view', 'grid');
        }
        this.renderChairColours();
      });
    }

    async loadData() {
      const url = this.root.getAttribute('data-json-url');
      const materialsPromise = this.loadMaterialLibrary();
      if (!url) {
        this.setStatus('Configuration data unavailable.', 'error');
        return;
      }
      try {
        this.setLoading(true);
        const response = await fetch(url, { cache: 'force-cache' });
        if (!response.ok) {
          throw new Error(`Failed to load configurator data (${response.status})`);
        }
        const json = await response.json();
        this.normalized = normaliseData(json);
        if (!this.normalized) {
          throw new Error('Configurator data missing or malformed');
        }
        await materialsPromise;
        this.render();
      } catch (error) {
        console.error('[Configurator] Data load failed', error);
        this.setStatus('We couldn\'t load the configurator data. Please try again later.', 'error');
      } finally {
        this.setLoading(false);
      }
    }

    async loadMaterialLibrary() {
      if (this.materialLibraryPromise) {
        return this.materialLibraryPromise;
      }

      if (!this.materialsJsonUrl) {
        this.materialLibrary = new Map();
        return this.materialLibrary;
      }

      this.materialLibraryPromise = fetch(this.materialsJsonUrl, { cache: 'force-cache' })
        .then(response => {
          if (!response.ok) {
            throw new Error(`Failed to load material metadata (${response.status})`);
          }
          return response.json();
        })
        .then(json => {
          this.materialLibrary = normaliseMaterialLibrary(json);
          return this.materialLibrary;
        })
        .catch(error => {
          console.error('[Configurator] Material metadata load failed', error);
          this.materialLibrary = new Map();
          return this.materialLibrary;
        });

      return this.materialLibraryPromise;
    }

    getMaterialMetadata(code) {
      const normalisedCode = normaliseMaterialCode(code);
      if (!normalisedCode) {
        return null;
      }
      return this.materialLibrary.get(normalisedCode) || null;
    }

    ensureMaterialTooltip() {
      if (this.materialTooltip && this.materialTooltipContent && this.materialTooltipPattern) {
        return this.materialTooltip;
      }
      const tooltip = createElement('div', {
        className: 'swatch_tooltip chair-table-tooltip',
        attrs: {
          role: 'dialog',
          'aria-hidden': 'true'
        }
      });
      const inner = createElement('div', { className: 'swatch_tooltip_inner' });
      const close = createElement('span', {
        className: 'close-tooltip',
        text: '×'
      });
      close.addEventListener('click', () => this.hideMaterialTooltip());
      const pattern = createElement('span', {
        className: 'pattern',
        attrs: { 'aria-hidden': 'true' }
      });
      const content = createElement('div', { className: 'tooltip_inner' });
      inner.appendChild(close);
      inner.appendChild(pattern);
      inner.appendChild(content);
      tooltip.appendChild(inner);
      // tooltip.style.display = 'none';
      document.body.appendChild(tooltip);
      this.materialTooltip = tooltip;
      this.materialTooltipContent = content;
      this.materialTooltipPattern = pattern;
      return tooltip;
    }

    renderMaterialTooltipContent(metadata, colour) {
      const content = this.materialTooltipContent;
      if (!content) {
        return;
      }
      content.innerHTML = '';

      const materialName = metadata?.label || colour.display || colour.code || 'Material';
      const fallbackPreview = () => {
        const productCode = colour.productCode;
        const feature = colour.feature || DEFAULT_COLOUR_FEATURE_KEYS[0];
        const option = colour.option || colour.code || colour.display;
        if (productCode && feature && option) {
          return buildCylindoMaterialUrl(
            this.cylindoCustomerId || DEFAULT_CYLINDO_ACCOUNT_ID,
            productCode,
            feature,
            option
          );
        }
        return null;
      };
      const previewUrl = colour.image || metadata?.image || fallbackPreview();
      if (this.materialTooltipPattern) {
        if (previewUrl) {
          this.materialTooltipPattern.style.backgroundImage = `url("${String(previewUrl).replace(/"/g, '\\"')}")`;
          this.materialTooltipPattern.style.backgroundColor = '';
        } else {
          this.materialTooltipPattern.style.backgroundImage = '';
          this.materialTooltipPattern.style.backgroundColor = metadata?.swatch || metadata?.colour || '#f3f4f6';
        }
      }

      const name = createElement('h3', {
        className: 'name',
        text: materialName
      });
      content.appendChild(name);

      const badgeLabel = colour?.materialTypeLabel || metadata?.type;
      if (badgeLabel) {
        content.appendChild(createElement('p', {
          className: 'type',
          html: `<b>${badgeLabel}</b>`
        }));
      }

      const description = metadata?.description;
      if (description && description !== materialName) {
        content.appendChild(createElement('p', {
          className: 'description',
          text: description
        }));
      }

      const appendDetail = (label, value) => {
        if (!value) return;
        content.appendChild(createElement('p', {
          className: 'detail',
          html: `<strong>${label}:</strong> ${value}`
        }));
      };

      appendDetail('Composition', metadata?.composition);
      appendDetail('We Recommend', metadata?.weRecommend);
      appendDetail('Durability', metadata?.technicalInfo || metadata?.durability);
      appendDetail('Care Instructions', metadata?.careInstructions);
      appendDetail('Delivery Time', metadata?.deliveryTime || colour.leadTime);

      if (!metadata || content.children.length === 0) {
        content.appendChild(createElement('p', {
          className: 'detail',
          text: 'Additional material details are unavailable.'
        }));
      }
    }

    showMaterialTooltip(target, colour) {
      if (!target) {
        return;
      }
      const tooltip = this.ensureMaterialTooltip();
      const metadata = this.getMaterialMetadata(colour.code);
      this.renderMaterialTooltipContent(metadata, colour);

      tooltip.classList.remove('is-visible');
      tooltip.setAttribute('aria-hidden', 'false');
      tooltip.style.display = 'block';

      const margin = 16;
      const rect = target.getBoundingClientRect();
      const tooltipRect = tooltip.getBoundingClientRect();
      const width = tooltipRect.width || tooltip.offsetWidth || 280;
      const height = tooltipRect.height || tooltip.offsetHeight || 200;

      let top = rect.top + rect.height / 2 - height / 2;
      top = Math.max(margin, Math.min(window.innerHeight - height - margin, top));

      let left = rect.left - width - margin;
      const detailsRect = this.els.detailsColumn?.getBoundingClientRect();
      if (detailsRect) {
        const desiredLeft = detailsRect.left - width - margin;
        if (Number.isFinite(desiredLeft)) {
          left = Math.min(left, desiredLeft);
        }
      }
      if (left < margin) {
        left = margin;
      }

      if (window.innerWidth <= 767) {
        tooltip.style.right = '0';
        tooltip.style.left = `0`;
        tooltip.style.bottom = `0px`;
        tooltip.style.top = `auto`;

      } else {
        tooltip.style.right = 'auto';
        tooltip.style.bottom = 'auto';
        tooltip.style.top = `${Math.round(top)}px`;
        tooltip.style.left = `${Math.round(left)}px`;
      }


      // tooltip.style.right = 'auto';
      // tooltip.style.bottom = 'auto';
      // tooltip.style.top = `${Math.round(top)}px`;
      // tooltip.style.left = `${Math.round(left)}px`;

      requestAnimationFrame(() => {
        tooltip.classList.add('is-visible');
        document.body.classList.add('chair-tabel-body_c');
      });
    }

    hideMaterialTooltip() {
      if (!this.materialTooltip) {
        return;
      }
      this.materialTooltip.classList.remove('is-visible');
      this.materialTooltip.setAttribute('aria-hidden', 'true');
      this.materialTooltip.style.display = 'none';
      document.body.classList.remove('chair-tabel-body_c');
    }

    setLoading(isLoading) {
      this.isLoading = isLoading;
      this.root.classList.toggle('is-loading', isLoading);
      if (isLoading) {
        this.setStatus('Loading configurator…', 'info');
      } else {
        this.setStatus('', 'info');
      }
    }
    resetStatus() {
      setTimeout(() => {
        this.setStatus('', 'info');
      }, 5000);
    }
    setStatus(message, status = 'info') {
      if (!this.els.status) return;
      this.els.status.textContent = message || '';
      this.els.status.dataset.state = status || 'info';
    }

    render() {
      this.renderTableRanges();
      this.renderChairRanges();
      this.renderViewToggle();
      this.updateSummary();
      this.updateSpecs();
      this.updatePrice();
      this.updateAddToCartState();
    }

    renderTableRanges() {
      if (!this.els.tableRange || !this.normalized) return;
      const combos = this.normalized.combos;
     const ranges = uniqueBy(
  combos.map(item => ({
    code: item.table.range,
    display: item.table.rangeDisplay,
    shortDisplay: item.table.rangeShortDisplay,
    image: item.table.rangeImage
  })),
  value => value.code
).sort((a, b) => a.code.localeCompare(b.code));

      this.els.tableRange.innerHTML = '';
      ranges.forEach(range => {
        const button = createElement('button', {
          className: 'config-tile config-tile--table',
          attrs: { type: 'button', 'data-value': range.code }
        });
        const img = createElement('img', {
          attrs: {
            src: range.image || FALLBACK_IMAGE,
            alt: range.display,
            loading: 'lazy'
          }
        });
        img.className = 'config-tile__image';
        button.appendChild(img);
        const labelText = range.display;
        button.appendChild(createElement('span', { className: 'config-tile__label', text: labelText }));
        button.appendChild(createElement('span', { className: 'tooltip-config-tile', text: labelText }));

        if (this.state.tableRange === range.code) {
          button.classList.add('is-selected');
        }
        button.addEventListener('click', () => {
          if (this.state.tableRange === range.code) return;
          const oldTableSize = this.state.tableSize;
          const oldTableFinish = this.state.tableFinish;
          this.state.tableRange = range.code;
          // Preserve old selections; downstream render fns will validate and fall back if invalid.
          this.state.tableSize = oldTableSize;
          this.state.tableFinish = oldTableFinish;
          this.renderTableRanges();
          this.renderTableSizes();
          this.renderTableFinishes();
          this.renderChairRanges();
          this.renderChairMaterials();
          this.renderChairLegs();
          this.updateSummary();
          this.updateSpecs();
          this.updatePrice();
          this.updateGroupLabels('table-range', range.display);
          this.focusNextGroup('table-range');
        });
        this.els.tableRange.appendChild(button);
      });

      if (!this.state.tableRange && ranges.length) {
        this.state.tableRange = ranges[0].code;
        this.updateGroupLabels('table-range', ranges[0].display);
        this.renderTableRanges();
        this.renderTableSizes();
        return;
      }

      this.renderTableSizes();
    }

    renderTableSizes() {
      if (!this.els.tableOptions || !this.normalized) return;
      const { tableRange } = this.state;
      const combos = this.normalized.combos.filter(item => item.table.range === tableRange);
      const sizes = uniqueBy(combos.map(item => ({
        code: item.table.size,
        display: item.table.sizeDisplay,
        numberOfChairs: item.combo.numberOfChairs,
        imageUrl: item.table.rangeImage
      })), value => value.code);

      if (this.state.tableSize && !sizes.some(size => size.code === this.state.tableSize)) {
        this.state.tableSize = null;
        this.state.tableFinish = null;
      }

      this.els.tableOptions.innerHTML = '';
      sizes.forEach(size => {
        const button = createElement('button', {
          className: 'config-tile config-tile--small',
          attrs: { type: 'button', 'data-value': size.code }
        });
        if (size.imageUrl) {
          const img = createElement('img', {
            className: 'config-tile__image',
            attrs: {
              src: size.imageUrl,
              alt: `${size.display} table`,
              loading: 'lazy'
            }
          });
         // button.appendChild(img);
        }
        button.appendChild(createElement('span', { className: 'config-tile__label', text: size.display }));
       // button.appendChild(createElement('span', { className: 'tooltip-config-tile', text: size.display }));

        if (size.numberOfChairs) {
          button.appendChild(createElement('span', {
            className: 'config-tile__meta',
            text: `${size.numberOfChairs} chairs`
          }));
        }
        if (this.state.tableSize === size.code) {
          button.classList.add('is-selected');
        }
        button.addEventListener('click', () => {
          if (this.state.tableSize === size.code) return;
          const oldTableFinish = this.state.tableFinish;
          this.state.tableSize = size.code;
          // Preserve old finish; renderTableFinishes() will validate and fall back if invalid.
          this.state.tableFinish = oldTableFinish;
          this.renderTableSizes();
          this.renderTableFinishes();
          this.renderChairRanges();
          this.renderChairMaterials();
          this.renderChairLegs();
          this.updateSummary();
          this.updateSpecs();
          this.updatePrice();
          this.updateGroupLabels('table-size', size.display);
          this.focusNextGroup('table-size');
        });
        this.els.tableOptions.appendChild(button);
      });

      if (!this.state.tableSize && sizes.length) {
        this.state.tableSize = sizes[0].code;
        this.updateGroupLabels('table-size', sizes[0].display);
        this.renderTableSizes();
        this.renderTableFinishes();
        return;
      }

      this.renderTableFinishes();
    }

    renderTableFinishes() {
      if (!this.els.tableFinishes || !this.normalized) return;
      const { tableRange, tableSize } = this.state;
      const combos = this.normalized.combos.filter(item => item.table.range === tableRange && item.table.size === tableSize);
      const finishes = uniqueBy(combos.map(item => ({
        code: item.table.finish,
        display: item.table.finishDisplay
      })), value => value.code);

      if (this.state.tableFinish && !finishes.some(finish => finish.code === this.state.tableFinish)) {
        this.state.tableFinish = null;
      }

      this.els.tableFinishes.innerHTML = '';
      finishes.forEach(finish => {
        const button = createElement('button', {
          className: 'config-swatch',
          attrs: { type: 'button', 'data-value': finish.code }
        });
        button.appendChild(createElement('span', { className: 'config-swatch__label', text: finish.display }));
        if (this.state.tableFinish === finish.code) {
          button.classList.add('is-selected');
        }
        button.addEventListener('click', () => {
          if (this.state.tableFinish === finish.code) return;
          this.state.tableFinish = finish.code;
          this.renderTableFinishes();
          this.renderChairRanges();
          this.renderChairMaterials();
          this.renderChairLegs();
          this.updateSummary();
          this.updateSpecs();
          this.updatePrice();
          this.updateGroupLabels('table-finish', finish.display);
          this.focusNextGroup('table-finish');
        });
        this.els.tableFinishes.appendChild(button);
      });

      if (!this.state.tableFinish && finishes.length) {
        this.state.tableFinish = finishes[0].code;
        this.updateGroupLabels('table-finish', finishes[0].display);
        this.renderTableFinishes();
        this.renderChairRanges();
        return;
      }

      this.renderChairRanges();
    }

    renderChairRanges() {
      if (!this.els.chairRange || !this.normalized) return;
      const { tableRange, tableSize, tableFinish } = this.state;
      const combos = this.normalized.combos.filter(item => {
        if (!tableRange || !tableSize || !tableFinish) return true;
        return item.table.range === tableRange && item.table.size === tableSize && item.table.finish === tableFinish;
      });
      // const ranges = uniqueBy(combos.map(item => ({
      //   code: item.chair.range,
      //   display: item.chair.rangeDisplay,
      //   image: item.chair.rangeImage
      // })), value => value.code);

      const ranges = uniqueBy(
  combos.map(item => ({
    code: item.chair.range,
    display: item.chair.rangeDisplay,
    image: item.chair.rangeImage
  })),
  value => value.code
).sort((a, b) => a.code.localeCompare(b.code));

      if (this.state.chairRange && !ranges.some(range => range.code === this.state.chairRange)) {
        this.state.chairRange = null;
        this.state.chairMaterial = null;
        this.state.chairColourName = null;
        this.state.chairColour = null;
        this.state.chairLeg = null;
      }

      this.els.chairRange.innerHTML = '';
      ranges.forEach(range => {
        const button = createElement('button', {
          className: 'config-tile',
          attrs: { type: 'button', 'data-value': range.code }
        });
        const img = createElement('img', {
          attrs: {
            src: range.image || FALLBACK_IMAGE,
            alt: range.display,
            loading: 'lazy'
          }
        });
        img.className = 'config-tile__image';
        button.appendChild(img);
        button.appendChild(createElement('span', { className: 'config-tile__label', text: range.display }));
        button.appendChild(createElement('span', { className: 'tooltip-config-tile', text: range.display }));

        if (this.state.chairRange === range.code) {
          button.classList.add('is-selected');
        }
        button.addEventListener('click', () => {
          if (this.state.chairRange === range.code) return;
          
          // Store old values before changing chair range
          const oldChairMaterial = this.state.chairMaterial;
          const oldChairColour = this.state.chairColour;
          const oldChairColourName = this.state.chairColourName;
          const oldChairLeg = this.state.chairLeg;
          
          this.state.chairRange = range.code;
          
          // Temporarily preserve old values - they will be validated in render functions
          this.state.chairMaterial = oldChairMaterial;
          this.state.chairColour = oldChairColour;
          this.state.chairColourName = oldChairColourName;
          this.state.chairLeg = oldChairLeg;
          
          this.renderChairRanges();
          this.renderChairMaterials();
          this.renderChairLegs();
          this.updateSummary();
          this.updateSpecs();
          this.updatePrice();
          this.updateGroupLabels('chair-range', range.display);
          this.focusNextGroup('chair-range');
        });
        this.els.chairRange.appendChild(button);
      });

      if (!this.state.chairRange && ranges.length) {
        this.state.chairRange = ranges[0].code;
        this.updateGroupLabels('chair-range', ranges[0].display);
        this.renderChairRanges();
        this.renderChairMaterials();
        return;
      }

      this.renderChairMaterials();
    }

    renderChairMaterials() {
      if (!this.els.materialTabs || !this.els.chairMaterials || !this.normalized) return;
      this.hideMaterialTooltip();
      const { tableRange, tableSize, tableFinish, chairRange } = this.state;
      const combos = this.normalized.combos.filter(item => {
        return (!tableRange || item.table.range === tableRange) &&
          (!tableSize || item.table.size === tableSize) &&
          (!tableFinish || item.table.finish === tableFinish) &&
          (!chairRange || item.chair.range === chairRange);
      });

      const materials = uniqueBy(combos.map(item => ({
        code: item.chair.material,
        display: item.chair.materialDisplay
      })), value => value.code);

      // Check if current material exists in new materials list
      if (this.state.chairMaterial && !materials.some(m => m.code === this.state.chairMaterial)) {
        // Old material doesn't exist, reset dependent values
        this.state.chairMaterial = null;
        this.state.chairColour = null;
        this.state.chairColourName = null;
        this.state.chairLeg = null;
      }

      this.els.materialTabs.innerHTML = '';
      materials.forEach(material => {
        const button = createElement('button', {
          className: 'config-tab',
          attrs: { type: 'button', 'data-value': material.code }
        });
        button.textContent = material.display;
        if (this.state.chairMaterial === material.code) {
          button.classList.add('is-active');
        }
        button.addEventListener('click', () => {
          if (this.state.chairMaterial === material.code) return;
          this.state.chairMaterial = material.code;
          this.state.chairColour = null;
          this.state.chairColourName = null;
          this.state.chairLeg = null;
          this.renderChairMaterials();
          this.renderChairColours();
          this.renderChairLegs();
          this.updateSummary();
          this.updateSpecs();
          this.updatePrice();
          this.updateGroupLabels('chair-material', material.display);
        });
        this.els.materialTabs.appendChild(button);
      });

      if (!this.state.chairMaterial && materials.length) {
        this.state.chairMaterial = materials[0].code;
        this.updateGroupLabels('chair-material', materials[0].display);
        this.renderChairMaterials();
        this.renderChairColours();
        return;
      }

      this.renderChairColours();
    }

    ensureChairMaterialsLoader() {
      if (!this.els.chairMaterials) return null;
      if (!this.chairMaterialsLoader) {
        this.chairMaterialsLoader = createElement('div', {
          className: 'halo-block-loader',
          attrs: { 'aria-hidden': 'true' }
        });
        this.chairMaterialsLoader.style.display = 'none';
      }
      if (!this.chairMaterialsLoader.parentElement) {
        this.els.chairMaterials.prepend(this.chairMaterialsLoader);
      }
      return this.chairMaterialsLoader;
    }

    setChairMaterialsLoading(isLoading) {
      if (!this.els.chairMaterials) return;
      const loader = isLoading ? this.ensureChairMaterialsLoader() : this.chairMaterialsLoader;
      if (isLoading) {
        this.els.chairMaterials.classList.add('has-halo-block-loader');
        this.els.chairMaterials.setAttribute('aria-busy', 'true');
        if (loader) {
          loader.style.display = '';
          loader.setAttribute('aria-hidden', 'false');
        }
      } else {
        this.els.chairMaterials.classList.remove('has-halo-block-loader');
        this.els.chairMaterials.removeAttribute('aria-busy');
        if (loader) {
          loader.style.display = 'none';
          loader.setAttribute('aria-hidden', 'true');
        }
      }
    }

    renderChairColours() {
      if (!this.els.chairMaterials || !this.normalized) return;
      this.hideMaterialTooltip();
      const loadToken = ++this.chairMaterialLoadToken;
      this.setChairMaterialsLoading(true);
      const finalize = () => {
        if (loadToken === this.chairMaterialLoadToken) {
          this.setChairMaterialsLoading(false);
        }
      };
      const { tableRange, tableSize, tableFinish, chairRange, chairMaterial } = this.state;
      const combos = this.normalized.combos.filter(item => {
        return (!tableRange || item.table.range === tableRange) &&
          (!tableSize || item.table.size === tableSize) &&
          (!tableFinish || item.table.finish === tableFinish) &&
          (!chairRange || item.chair.range === chairRange) &&
          (!chairMaterial || item.chair.material === chairMaterial);
      });

      const colours = uniqueBy(combos.map(item => ({
        code: item.chair.colour,
        display: item.chair.colourDisplay,
        image: item.chair.colourImage,
        feature: item.chair.colourFeature,
        option: item.chair.colourOption,
        productCode: item.combo.cylindoProductCode,
        leadTime: item.combo.leadTime || null
      })), value => value.code).map(colour => {
        const metadata = this.getMaterialMetadata(colour.code);
        const { key, label } = normaliseMaterialType(metadata?.type);
        return {
          ...colour,
          materialTypeKey: key,
          materialTypeLabel: label,
          materialMetadata: metadata || null,
          leadTime: colour.leadTime || metadata?.deliveryTime || metadata?.deliveryTimeRange || metadata?.deliveryTimeLabel || null
        };
      });

      this.renderMaterialFilters(colours);

      const visibleColours = this.materialFilter === 'all'
        ? colours
        : colours.filter(colour => colour.materialTypeKey === this.materialFilter);

      const loader = this.ensureChairMaterialsLoader();
      this.els.chairMaterials.innerHTML = '';
      if (loader) {
        this.els.chairMaterials.appendChild(loader);
      }
      if (!visibleColours.length) {
        const empty = createElement('div', {
          className: 'material-swatch material-swatch--empty'
        });
        empty.textContent = 'No upholstery options match this filter.';
        this.els.chairMaterials.appendChild(empty);
        finalize();
        return;
      }

      // Check if current colour exists in new colours list (considering filter)
      if (this.state.chairColour && !visibleColours.some(colour => colour.code === this.state.chairColour)) {
        // Old colour doesn't exist in filtered list, check all colours
        if (!colours.some(colour => colour.code === this.state.chairColour)) {
          // Old colour doesn't exist at all, reset to first available
          const first = visibleColours[0];
          this.state.chairColour = first.code;
          this.state.chairColourName = first.materialMetadata.label;
          const materialDisplay = this.getDisplayFor('chairMaterial') || first.display;
          this.updateGroupLabels('chair-material', `${materialDisplay} • ${first.materialMetadata.label}`);
        } else {
          // Old colour exists but is filtered out - reset to first visible
          const first = visibleColours[0];
          this.state.chairColour = first.code;
          this.state.chairColourName = first.materialMetadata.label;
          const materialDisplay = this.getDisplayFor('chairMaterial') || first.display;
          this.updateGroupLabels('chair-material', `${materialDisplay} • ${first.materialMetadata.label}`);
        }
      }

      if (!this.state.chairColour && visibleColours.length) {
        const first = visibleColours[0];
        this.state.chairColour = first.code;
        this.state.chairColourName = first.materialMetadata.label;
        const materialDisplay = this.getDisplayFor('chairMaterial') || first.display;
        this.updateGroupLabels('chair-material', `${materialDisplay} • ${first.materialMetadata.label}`);
        //this.updateGroupLabels('chair-material', `${materialDisplay} • ${first.display}`);
      }

      const preloadSet = new Set();
      const preloadPromises = [];

      const createColourButton = colour => {
        const button = createElement('button', {
          className: 'material-swatch',
          attrs: {
            type: 'button',
            'data-value': colour.code,
            'data-material-code': colour.code || ''
          }
        });
        const metadata = colour.materialMetadata || this.getMaterialMetadata(colour.code);
        if (colour.materialTypeKey) {
          button.dataset.materialTypeKey = colour.materialTypeKey;
        }
        if (colour.materialTypeLabel) {
          button.dataset.materialType = colour.materialTypeLabel;
        } else if (metadata?.type) {
          button.dataset.materialType = metadata.type;
        }
        if (colour.leadTime) {
          button.dataset.leadTime = colour.leadTime;
        }
        if (metadata?.label) {
          button.dataset.materialLabel = metadata.label;
        }
        const swatchImage = colour.image ||
          metadata?.image ||
          buildCylindoMaterialUrl(
            this.cylindoCustomerId || DEFAULT_CYLINDO_ACCOUNT_ID,
            colour.productCode,
            colour.feature || DEFAULT_COLOUR_FEATURE_KEYS[0],
            colour.option || colour.code || colour.display
          );
        const fallback = createElement('span', {
          className: swatchImage ? 'material-swatch__fallback material-swatch__fallback--image' : 'material-swatch__fallback',
          attrs: { 'aria-hidden': 'true' }
        });
        if (swatchImage) {
          if (!preloadSet.has(swatchImage)) {
            preloadSet.add(swatchImage);
            preloadPromises.push(preloadImage(swatchImage));
          }
          const safeImage = swatchImage.replace(/"/g, '\\"');
          fallback.style.backgroundImage = `url("${safeImage}")`;
        } else {
          fallback.textContent = colour.display?.charAt(0) || '•';
        }
        button.appendChild(fallback);
        button.appendChild(createElement('span', {
          className: 'material-swatch__label',
          text: colour.display
        }));
        if (this.state.chairColour === colour.code) {
          button.classList.add('is-selected');
        }
          const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
        button.addEventListener('click', () => {
          if (this.state.chairColour === colour.code) return;
          this.state.chairColour = colour.code;
          this.state.chairColourName = colour.materialMetadata?.label || this.state.chairColour;
          this.state.chairLeg = null;
          this.renderChairColours();
          this.renderChairLegs();
          this.updateSummary();
          this.updateSpecs();
          this.updatePrice();
          const materialDisplay = this.getDisplayFor('chairMaterial') || colour.display;
          if(isTouchDevice){
           // console.log('p')
          this.showMaterialTooltip(button, colour);
          }
          // this.updateGroupLabels('chair-material', `${materialDisplay} • ${colour.display}fff`);
          this.updateGroupLabels('chair-material', `${materialDisplay} • ${colour.materialMetadata.label}`);
          if (this.hasSelectableLegs) {
            this.focusNextGroup('chair-material');
          } else {
            this.focusNextGroup('chair-legs');
          }
        });

       // console.log('isTouchDevice',isTouchDevice)
      
        if (!isTouchDevice) {
          button.addEventListener('mouseenter', () => {
            this.showMaterialTooltip(button, colour);
          });
          button.addEventListener('focus', () => {
            this.showMaterialTooltip(button, colour);
          });
          button.addEventListener('mouseleave', this.boundHideMaterialTooltip);
          button.addEventListener('blur', this.boundHideMaterialTooltip);

        }
        return button;
      };

      const appendColourButton = colour => {
        const button = createColourButton(colour);
        this.els.chairMaterials.appendChild(button);
      };

      if (this.materialView === 'grid') {
        const groupsMap = new Map();
        visibleColours.forEach(colour => {
          const key = colour.materialTypeKey || 'other';
          const label = colour.materialTypeLabel || 'Others';
          if (!groupsMap.has(key)) {
            groupsMap.set(key, { key, label, colours: [] });
          }
          groupsMap.get(key).colours.push(colour);
        });
        const orderKeys = (this.materialTypeOrder || []).filter(key => key !== 'all');
        const orderedGroups = orderKeys.length
          ? orderKeys.filter(key => groupsMap.has(key)).map(key => groupsMap.get(key))
          : Array.from(groupsMap.values()).sort((a, b) => a.label.localeCompare(b.label));
        orderedGroups.forEach((group, index) => {
          const title = createElement('div', {
            className: 'material-group-title',
            text: group.label
          });
          if (index === 0) {
            title.classList.add('material-group-title--first');
          }
          this.els.chairMaterials.appendChild(title);
          group.colours.forEach(colour => appendColourButton(colour));
        });
      } else {
        const leadTimeGroups = new Map();
        visibleColours.forEach(colour => {
          const rawLeadTime = colour.leadTime && colour.leadTime.trim();
          const label = rawLeadTime || 'Lead time unavailable';
          if (!leadTimeGroups.has(label)) {
            leadTimeGroups.set(label, []);
          }
          leadTimeGroups.get(label).push(colour);
        });

        const orderedLeadGroups = Array.from(leadTimeGroups.entries()).sort((a, b) => {
          const labelA = a[0].toLowerCase();
          const labelB = b[0].toLowerCase();
          if (labelA === labelB) return 0;
          if (labelA === 'lead time unavailable') return 1;
          if (labelB === 'lead time unavailable') return -1;
          return labelA.localeCompare(labelB);
        });
        orderedLeadGroups.forEach(([leadTimeLabel, coloursInGroup], index) => {
          const title = createElement('div', {
            className: 'material-group-title material-group-title--lead',
            text: leadTimeLabel
          });
          if (index === 0) {
            title.classList.add('material-group-title--first');
          }
          this.els.chairMaterials.appendChild(title);
          coloursInGroup.forEach(colour => appendColourButton(colour));
        });
      }

      this.renderChairLegs();
      if (preloadPromises.length) {
        Promise.all(preloadPromises).catch(() => { }).finally(finalize);
      } else {
        finalize();
      }
    }


    renderChairLegs() {
      if (!this.els.chairLegs || !this.normalized) return;
      const { tableRange, tableSize, tableFinish, chairRange, chairMaterial, chairColour } = this.state;
      const combos = this.normalized.combos.filter(item => {
        return (!tableRange || item.table.range === tableRange) &&
          (!tableSize || item.table.size === tableSize) &&
          (!tableFinish || item.table.finish === tableFinish) &&
          (!chairRange || item.chair.range === chairRange) &&
          (!chairMaterial || item.chair.material === chairMaterial) &&
          (!chairColour || item.chair.colour === chairColour);
      });

      const legs = uniqueBy(combos.map(item => ({
        code: item.chair.leg,
        display: item.chair.legDisplay
      })), value => value.code);

      // Check if current leg exists in new legs list
      if (this.state.chairLeg && !legs.some(leg => leg.code === this.state.chairLeg)) {
        // Old leg doesn't exist, reset to null (will be set to first available below)
        this.state.chairLeg = null;
      }

      this.els.chairLegs.innerHTML = '';
      if (!legs.length || (legs.length === 1 && legs[0].code === LEG_NONE_KEY)) {
        this.state.chairLeg = null;
        this.toggleGroup('chair-legs', false);
        this.updateGroupLabels('chair-legs', 'Standard');
        this.updateSummary();
        this.updatePrice();
        this.hasSelectableLegs = false;
        return;
      }

      this.toggleGroup('chair-legs', true);
      this.hasSelectableLegs = legs.some(leg => leg.code !== LEG_NONE_KEY);

      legs.forEach(leg => {
        const button = createElement('button', {
          className: 'config-swatch',
          attrs: { type: 'button', 'data-value': leg.code }
        });
        button.appendChild(createElement('span', { className: 'config-swatch__label', text: leg.display }));
        if ((this.state.chairLeg || LEG_NONE_KEY) === leg.code) {
          button.classList.add('is-selected');
        }
        button.addEventListener('click', () => {
          if (this.state.chairLeg === leg.code) return;
          this.state.chairLeg = leg.code === LEG_NONE_KEY ? null : leg.code;
          this.renderChairLegs();
          this.updateSummary();
          this.updateSpecs();
          this.updatePrice();
          this.updateGroupLabels('chair-legs', leg.display);
          this.focusNextGroup('chair-legs');
        });
        this.els.chairLegs.appendChild(button);
      });

      if (!this.state.chairLeg && legs.length) {
        const firstLeg = legs[0];
        this.state.chairLeg = firstLeg.code === LEG_NONE_KEY ? null : firstLeg.code;
        this.updateGroupLabels('chair-legs', firstLeg.display);
        this.renderChairLegs();
        return;
      }
    }

    renderMaterialFilters(colours) {
      if (!this.els.materialFilters) return;
      const typeMap = new Map();
      colours.forEach(colour => {
        if (!colour.materialTypeKey) return;
        if (!typeMap.has(colour.materialTypeKey)) {
          typeMap.set(colour.materialTypeKey, colour.materialTypeLabel || 'Others');
        }
      });
      const typeOptions = Array.from(typeMap.entries()).map(([key, label]) => ({ key, label }));
      typeOptions.sort((a, b) => a.label.localeCompare(b.label));
      const available = [{ key: 'all', label: 'All' }, ...typeOptions];
      this.materialTypeOrder = available.map(option => option.key);
      if (!available.some(option => option.key === this.materialFilter)) {
        this.materialFilter = 'all';
      }

      this.els.materialFilters.innerHTML = '';
      available.forEach(option => {
        const button = createElement('button', {
          className: 'config-tab config-tab--small',
          attrs: {
            type: 'button',
            'data-filter': option.key
          },
          text: option.label
        });
        if (this.materialFilter === option.key) {
          button.classList.add('is-active');
        }
        button.setAttribute('aria-pressed', String(this.materialFilter === option.key));
        button.addEventListener('click', () => {
          if (this.materialFilter === option.key) return;
          this.materialFilter = option.key;
          this.renderChairColours();
        });
        this.els.materialFilters.appendChild(button);
      });
    }

    getViewModeLabel() {
      const activeMaterialTab = this.els.materialTabs?.querySelector('button.is-active[data-value]');
      if (activeMaterialTab) {
        const tabLabel = activeMaterialTab.textContent?.trim();
        if (tabLabel) {
          return `${tabLabel} View`;
        }
      }

      const filterButtons = new Map(
        [...(this.els.materialFilters?.querySelectorAll('button[data-filter]') || [])].map(button => [
          button.getAttribute('data-filter'),
          button.textContent.trim()
        ])
      );

      const resolveLabel = label => {
        if (!label) return null;
        const normalised = label.toLowerCase();
        if (normalised.includes('leather')) {
          return 'Leather View';
        }
        if (normalised.includes('fabric') || normalised.includes('fabrics') || normalised.includes('cloth')) {
          return 'Fabric View';
        }
        return `${label} View`;
      };

      if (this.materialFilter !== 'all') {
        return resolveLabel(filterButtons.get(this.materialFilter)) || 'Fabric View';
      }

      const firstTypeKey = this.materialTypeOrder?.find(key => key !== 'all');
      if (firstTypeKey) {
        return resolveLabel(filterButtons.get(firstTypeKey)) || 'Fabric View';
      }

      return 'Fabric View';
    }

    renderViewToggle() {
      if (!this.els.viewToggle) return;
      this.els.viewToggle.innerHTML = '';
      const views = [
        { key: 'list', label: 'Delivery Time' },
        { key: 'grid', label: this.getViewModeLabel() }
      ];
      views.forEach(view => {
        const button = createElement('button', {
          className: 'config-tab config-tab--small',
          attrs: {
            type: 'button',
            'data-view': view.key,
            'aria-pressed': String(this.materialView === view.key)
          },
          text: view.label
        });
        if (this.materialView === view.key) {
          button.classList.add('is-active');
        }
        this.els.viewToggle.appendChild(button);
      });
      if (this.els.chairMaterials) {
        this.els.chairMaterials.setAttribute('data-view', 'grid');
      }
    }

    clearChairSelections() {
      this.state.chairRange = null;
      this.state.chairMaterial = null;
      this.state.chairColour = null;
      this.state.chairColourName = null;
      this.state.chairLeg = null;
    }

    resetConfigurator() {
      this.state.tableRange = null;
      this.state.tableSize = null;
      this.state.tableFinish = null;
      this.clearChairSelections();
      this.materialFilter = 'all';
      this.materialView = 'grid';
      if (this.els.qtyInput) {
        this.state.quantity = this.defaultQuantity;
        this.els.qtyInput.value = String(this.defaultQuantity);
      } else {
        this.state.quantity = this.defaultQuantity;
      }
      this.state.coriguardSelected = false;
      this.state.coriguardVariantId = null;
      this.state.coriguardPrice = null;
      if (this.els.coriguardCheckbox) {
        this.els.coriguardCheckbox.checked = false;
      }
      this.updateCoriguard(null);
      this.render();
      this.resetGroupStates();
      this.updateSelectionProgress('table-range');
    }

    resetGroupStates() {
      if (!this.els.groups) return;
      const groups = [...this.els.groups.querySelectorAll('.config-group')];
      groups.forEach((group, index) => {
        const name = group.getAttribute('data-group');
        if (!name) return;
        this.toggleGroup(name, index === 0);
      });
    }

    updateSelectionProgress(groupName,count=0) {
      count++
      if (!this.els.progressLabel) return;
      if (!this.els.groups) {
        this.els.progressLabel.textContent = this.progressDefaultText;
        return;
      }
      const group = this.els.groups.querySelector(`[data-group="${groupName}"]`);
      if (!group) {
        this.els.progressLabel.textContent = this.progressDefaultText;
        return;
      }
      const headerLabel = group.querySelector('.config-group__header span');
      const selectedLabel = group.querySelector('[data-selected-label]');
      const headerText = `${headerLabel?.textContent?.trim()}`;
      //headerLabel.textContent = `${count}${headerText}`
      const selectedText = selectedLabel?.textContent?.trim();
      let output = headerText || this.progressDefaultText;
      if (selectedText) {
        output = `${output} ${selectedText}`;
      }
      this.els.progressLabel.textContent = output;
    }

    updateGroupLabels(groupName, label) {
      if (!groupName || !this.els.groups) return;
      const group = this.els.groups.querySelector(`[data-group="${groupName}"]`);
      if (!group) return;
      const labelEl = group.querySelector('[data-selected-label]');
      if (!labelEl) return;
      labelEl.textContent = label || '';
      if (group.classList.contains('is-open')) {
        this.updateSelectionProgress(groupName);
      }
    }

    // updateSummary() {
    //   if (this.els.summaryTable) {
    //     const tableText = this.state.tableRange && this.state.tableSize && this.state.tableFinish
    //       ? `${this.getDisplayFor('tableRange')} • ${this.getDisplayFor('tableSize')} • ${this.getDisplayFor('tableFinish')}`
    //       : '—';
    //     this.els.summaryTable.textContent = tableText;
    //   }
    //   if (this.els.summaryChair) {
    //     const chairText = this.state.chairRange && this.state.chairMaterial && this.state.chairColourName
    //       ? `${this.getDisplayFor('chairRange')} • ${this.getDisplayFor('chairMaterial')} • ${this.getDisplayFor('chairColour')}${this.state.chairLeg ? ` • ${this.getDisplayFor('chairLeg')}` : ''}`
    //       : '—';
    //     this.els.summaryChair.textContent = chairText;
    //   }
    //   if (this.els.productTitle) {
    //     const titleParts = [];
    //     if (this.getDisplayFor('tableRange')) {
    //       titleParts.push(this.getDisplayFor('tableRange'));
    //     }
    //     if (this.getDisplayFor('chairRange')) {
    //       titleParts.push(`with ${this.getDisplayFor('chairRange')} chairs`);
    //     }
    //     this.els.productTitle.textContent = titleParts.length ? titleParts.join(' ') : 'Dining Set';
    //   }
    // }

    updateSummary() {
  const createExpandableList = (items) => {
    const firstItem = items[0];
    const remainingItems = items.slice(1);

    return `
      <div class="expandable-wrapper">
        <ul class="expandable-list">
          <li>${firstItem}</li>
          <div class="hidden-items" style="max-height:0; overflow:hidden; transition:max-height 0.3s ease;">
            ${remainingItems.map(i => `<li>${i}</li>`).join('')}
          </div>
        </ul>
        ${remainingItems.length > 0 ? `<button class="toggle-btn">+</button>` : ''}
      </div>
    `;
  };

  if (this.els.summaryTable) {
    if (this.state.tableRange && this.state.tableSize && this.state.tableFinish) {
      const items = [
        this.getDisplayFor('tableRange'),
        this.getDisplayFor('tableSize'),
        this.getDisplayFor('tableFinish'),
      ];
      this.els.summaryTable.innerHTML = createExpandableList(items);
    } else {
      this.els.summaryTable.innerHTML = '—';
    }
  }

  if (this.els.summaryChair) {
    if (this.state.chairRange && this.state.chairMaterial && this.state.chairColourName) {
      const items = [
        this.getDisplayFor('chairRange'),
        this.getDisplayFor('chairMaterial'),
        this.getDisplayFor('chairColour'),
      ];

      if (this.state.chairLeg) {
        items.push(this.getDisplayFor('chairLeg'));
      }

      this.els.summaryChair.innerHTML = createExpandableList(items);
    } else {
      this.els.summaryChair.innerHTML = '—';
    }
  }

  // Product title remains same
  if (this.els.productTitle) {
    const titleParts = [];
    if (this.getDisplayFor('tableRange')) titleParts.push(this.getDisplayFor('tableRange'));
    if (this.getDisplayFor('chairRange')) titleParts.push(`with ${this.getDisplayFor('chairRange')} chairs`);
    this.els.productTitle.textContent = titleParts.length ? titleParts.join(' ') : 'Dining Set';
  }

  this.addToggleBehavior();
}

addToggleBehavior() {
  const buttons = document.querySelectorAll('.toggle-btn');

  buttons.forEach(btn => {
    btn.onclick = () => {
      const hiddenSection = btn.closest('.expandable-wrapper').querySelector('.hidden-items');

      if (hiddenSection.style.maxHeight === "0px" || hiddenSection.style.maxHeight === "") {
        hiddenSection.style.maxHeight = hiddenSection.scrollHeight + "px";
        btn.textContent = "−";
      } else {
        hiddenSection.style.maxHeight = "0px";
        btn.textContent = "+";
      }
    };
  });
}


    getDisplayFor(key) {
      if (!this.normalized) return '';
      const combos = this.normalized.combos;
      if (!combos.length) return '';
      const combo = this.findMatchingCombo();
      const fallback = combos.find(item => this.matchesPartial(item));
      const target = combo || fallback;
      if (!target) return '';
      switch (key) {
        case 'tableRange':
          return target.table.rangeDisplay;
        case 'tableSize':
          return target.table.sizeDisplay;
        case 'tableFinish':
          return target.table.finishDisplay;
        case 'chairRange':
          return target.chair.rangeDisplay;
        case 'chairMaterial':
          return target.chair.materialDisplay;
        case 'chairColour':
          // return target.chair.colourDisplay;
          return this.state.chairColourName;
        case 'chairLeg':
          return target.chair.legDisplay;
        default:
          return '';
      }
    }

    matchesPartial(item) {
      const { tableRange, tableSize, tableFinish, chairRange, chairMaterial, chairColour, chairLeg, chairColourName } = this.state;
      if (tableRange && item.table.range !== tableRange) return false;
      if (tableSize && item.table.size !== tableSize) return false;
      if (tableFinish && item.table.finish !== tableFinish) return false;
      if (chairRange && item.chair.range !== chairRange) return false;
      if (chairMaterial && item.chair.material !== chairMaterial) return false;
      if (chairColour && item.chair.colour !== chairColour) return false;
      if (chairLeg && item.chair.leg !== chairLeg) return false;
      return true;
    }

    findMatchingCombo() {
      if (!this.normalized) return null;
      const { tableRange, tableSize, tableFinish, chairRange, chairMaterial, chairColour, chairColourName } = this.state;
      if (!tableRange || !tableSize || !tableFinish || !chairRange || !chairMaterial || !chairColour) {
        return null;
      }
      const legKey = this.state.chairLeg ?? LEG_NONE_KEY;
      return this.normalized.combos.find(item =>
        item.table.range === tableRange &&
        item.table.size === tableSize &&
        item.table.finish === tableFinish &&
        item.chair.range === chairRange &&
        item.chair.material === chairMaterial &&
        item.chair.colour === chairColour &&
        (item.chair.leg || LEG_NONE_KEY) === legKey
      ) || null;
    }

    findTableMatch() {
      if (!this.normalized) return null;
      const { tableRange, tableSize, tableFinish } = this.state;
      if (!tableRange || !tableSize || !tableFinish) {
        return null;
      }
      return this.normalized.combos.find(item =>
        item.table.range === tableRange &&
        item.table.size === tableSize &&
        item.table.finish === tableFinish
      ) || null;
    }

    findChairMatch() {
      if (!this.normalized) return null;
      const { chairRange, chairMaterial, chairColour } = this.state;
      if (!chairRange || !chairMaterial || !chairColour) {
        return null;
      }
      const legKey = this.state.chairLeg ?? LEG_NONE_KEY;
      return this.normalized.combos.find(item =>
        item.chair.range === chairRange &&
        item.chair.material === chairMaterial &&
        item.chair.colour === chairColour &&
        (item.chair.leg || LEG_NONE_KEY) === legKey
      ) || null;
    }
    async checkProductQuantity(tableVariantId, chairVariantId, chairQuantity) {
      const data = [
        { id: tableVariantId, qty: 1 },
        { id: chairVariantId, qty: chairQuantity }
      ];

      let dataToSend = {
        // shop: "coricraft-co-za.myshopify.com",
        variant_ids: [tableVariantId, chairVariantId]
      };

      try {
        const response = await fetch("/apps/coriapp/get-variant-quantities", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(dataToSend)
        });

        if (!response.ok) {
          throw new Error("HTTP error: " + response.status);
        }

        const result = await response.json();
        console.log("Variant quantities:", result);

        if (!result.data) {
          return false;
        }

        // 🚀 Check quantities
        for (let variant of result.data) {
          const availableQty =
            variant.inventoryItem.inventoryLevels.edges[0].node.quantities[0].quantity;
            const inventory_policy =variant.inventoryPolicy

          // find required qty from our data[]
          const variantNumericId = variant.id.split("/").pop();

          // Match with your local numeric ID
          const required = data.find(x => String(x.id) === String(variantNumericId))?.qty || 0;

          console.log(
            `Variant ${variant.id}: Required = ${required}, Available = ${availableQty}`
          );


      if(inventory_policy==='CONTINUE')
          {
            return true
          }


          // ❌ if ANY product does not have required qty → return false
          if (availableQty < required) {
            return false;
          }
        }

        // ✔ All good → return true
        return true;

      } catch (error) {
        console.error("Fetch Error:", error);
        alert("Error fetching variant quantities: " + error.message);
        return false;
      }
    }



    getSelectedTableVariantId() {
      const combo = this.currentCombo || this.findMatchingCombo();
      if (combo?.table?.variantId) {
        return combo.table.variantId;
      }
      const tableMatch = this.findTableMatch();
      return tableMatch?.table?.variantId || null;
    }

    getSelectedChairVariantId() {
      const combo = this.currentCombo || this.findMatchingCombo();
      if (combo?.chair?.variantId) {
        return combo.chair.variantId;
      }
      const chairMatch = this.findChairMatch();
      return chairMatch?.chair?.variantId || null;
    }

    getSelectedChairCount() {
      const combo = this.currentCombo || this.findMatchingCombo();
      const directCount = combo?.combo?.numberOfChairs ?? combo?.table?.numberOfChairs;
      if (directCount != null) {
        return directCount;
      }
      const tableMatch = this.findTableMatch();
      return tableMatch?.combo?.numberOfChairs ?? tableMatch?.table?.numberOfChairs ?? null;
    }

    updateSpecs() {
      const combo = this.findMatchingCombo();
      const tableMatch = this.findTableMatch();
      const chairMatch = this.findChairMatch();
      const tableVariantId = this.getSelectedTableVariantId();
      const chairVariantId = this.getSelectedChairVariantId();
      const chairCount = this.getSelectedChairCount();

      if (this.els.specTable) {
        this.els.specTable.textContent = combo
          ? `${combo.table.rangeDisplay} — ${combo.table.sizeDisplay}`
          : '—';
      }
      if (this.els.specChair) {
        this.els.specChair.textContent = combo
          ? `${combo.chair.rangeDisplay}`
          : '—';
      }
      const colourSummary = combo
        ? `${combo.chair.materialDisplay} • ${combo.chair.colourDisplay}${combo.chair.leg && combo.chair.leg !== LEG_NONE_KEY ? ` • ${combo.chair.legDisplay}` : ''}`
        : '—';
      if (this.els.specColour) {
        this.els.specColour.textContent = colourSummary;
      }
      if (this.els.summaryColour) {
        this.els.summaryColour.textContent = colourSummary;
      }
      if (this.els.delivery && combo?.combo?.leadTime) {
        this.els.delivery.textContent = combo.combo.leadTime;
      }
      if (this.els.chairAmount) {
        const amount = combo?.combo?.numberOfChairs || combo?.table?.numberOfChairs || chairCount || null;
        this.els.chairAmount.textContent = amount != null ? amount : '—';
      }
      if (this.els.variantColour) {
        //this.els.variantColour.textContent = combo?.chair?.colourDisplay || '—';
        this.els.variantColour.textContent = this.state.chairColourName || '—';
      }
      if (this.els.variantSize) {
        this.els.variantSize.textContent = combo?.table?.sizeDisplay || '—';
      }
      if (this.els.specTableVariant) {
        const tableId = tableVariantId || tableMatch?.table?.variantId || combo?.table?.variantId;
        const tableVariantText = tableId ? `Table Variant ID: ${tableId}` : 'Table Variant ID: —';
        this.els.specTableVariant.textContent = tableVariantText;
      }
      // if (this.els.leadTime) {
      //   const leadTime = combo?.combo?.leadTime;
      //   this.els.leadTime.textContent = leadTime;
      // }
      if (this.els.leadTime?.length && combo?.combo?.leadTime) {
        this.els.leadTime.forEach(el => {
          el.textContent = combo.combo.leadTime;
        });
      }

      if (this.els.tableDimension) {
        const tableDimension = tableMatch?.table?.dimensions;
        let finalHtml = "";
        Object.entries(tableDimension).forEach(([key, value]) => {
          finalHtml += `
          <div class="productView-info-item">
            <span class="productView-info-name">${key}:</span>
            <span class="productView-info-value">${value.trim()}</span>
          </div>
        `;
        });
        this.els.tableDimension.innerHTML = finalHtml
      }
      if (this.els.chairDimension) {
        const tableDimension = chairMatch?.chair?.dimensions;
        let finalHtml = "";
        Object.entries(tableDimension).forEach(([key, value]) => {
          finalHtml += `
          <div class="productView-info-item">
            <span class="productView-info-name">${key}:</span>
            <span class="productView-info-value">${value.trim()}</span>
          </div>
        `;
        });
        this.els.chairDimension.innerHTML = finalHtml
      }
      if (this.els.tableDes) {
        const description = tableMatch?.table?.description;
        this.els.tableDes.textContent = description
      }
      if (this.els.chairDes) {
        const description = chairMatch?.chair?.description;
        this.els.chairDes.textContent = description
      }
      if (this.els.specChairVariant) {
        const chairId = chairVariantId || chairMatch?.chair?.variantId || combo?.chair?.variantId;
        const chairVariantText = chairId ? `Chair Variant ID: ${chairId}` : 'Chair Variant ID: —';
        this.els.specChairVariant.textContent = chairVariantText;
      }
      if (this.els.specChairQuantity) {
        const referenceCount = combo ? (combo.combo?.numberOfChairs ?? combo.table?.numberOfChairs ?? null) : null;
        const parsedCount = normaliseNumber(referenceCount ?? chairCount);
        const displayCount = parsedCount && parsedCount > 0 ? parsedCount : '—';
        this.els.specChairQuantity.textContent = `Chairs: ${displayCount}`;
      }
    }

    updateCoriguard(combo) {

      if (!this.els.coriguard) return;
      const previousVariantId = this.state.coriguardVariantId;
      const variantId = combo?.chair?.coriguardVariantId || null;
      const priceValue = combo?.chair?.priceCoriguard ?? combo?.combo?.priceCoriguard ?? null;
      const numericPrice = typeof priceValue === 'number' ? priceValue : Number(priceValue);
      const hasPrice = Number.isFinite(numericPrice) && numericPrice >= 0;
      const hasVariant = typeof variantId === 'string' && variantId;
      const hasCoriguard = Boolean(hasVariant && hasPrice);

      if (hasCoriguard) {
        this.els.coriguard.hidden = false;
        if (this.els.coriguardPrice) {
          this.els.coriguardPrice.textContent = formatMoney(numericPrice, this.currency);
        }
        if (this.els.coriguardCheckbox) {
          this.els.coriguardCheckbox.value = variantId;
          this.els.coriguardCheckbox.dataset.coriguardPrice = String(numericPrice);
          this.els.coriguardCheckbox.dataset.coriguardVariantId = variantId;
          const shouldRemainChecked = this.state.coriguardSelected && previousVariantId === variantId;
          this.els.coriguardCheckbox.checked = shouldRemainChecked;
          this.state.coriguardSelected = shouldRemainChecked;
        }
        this.state.coriguardVariantId = variantId;
        this.state.coriguardPrice = numericPrice;
      } else {
        this.els.coriguard.hidden = true;
        if (this.els.coriguardCheckbox) {
          this.els.coriguardCheckbox.checked = false;
          this.els.coriguardCheckbox.value = '';
          delete this.els.coriguardCheckbox.dataset.coriguardPrice;
          delete this.els.coriguardCheckbox.dataset.coriguardVariantId;
        }
        if (this.els.coriguardPrice) {
          this.els.coriguardPrice.textContent = formatMoney(0, this.currency);
        }
        this.state.coriguardVariantId = null;
        this.state.coriguardPrice = null;
        this.state.coriguardSelected = false;
      }
    }

    getChairQuantity(combo) {
      const sourceCombo = combo || this.findMatchingCombo();
      if (!sourceCombo) {
        const fallbackCount = normaliseNumber(this.getSelectedChairCount());
        if (fallbackCount && fallbackCount > 0) {
          return fallbackCount;
        }
        const fallbackQuantity = normaliseNumber(this.state.quantity);
        return fallbackQuantity && fallbackQuantity > 0 ? fallbackQuantity : 1;
      }
      const rawCount = sourceCombo?.combo?.numberOfChairs ?? sourceCombo?.table?.numberOfChairs ?? null;
      const parsed = normaliseNumber(rawCount);
      if (parsed && parsed > 0) {
        return parsed;
      }
      const fallbackCount = normaliseNumber(this.getSelectedChairCount());
      if (fallbackCount && fallbackCount > 0) {
        return fallbackCount;
      }
      const fallback = normaliseNumber(this.state.quantity);
      return fallback && fallback > 0 ? fallback : 1;
    }

    syncChairQuantity(combo) {
      const parsedCount = this.getChairQuantity(combo);
      if (!parsedCount || parsedCount <= 0) {
        return;
      }
      this.state.quantity = parsedCount;
      this.defaultQuantity = parsedCount;
      if (this.els.qtyInput) {
        this.els.qtyInput.value = String(parsedCount);
      }
      this.updateSummary();
    }
    updatePrice() {
      const combo = this.findMatchingCombo();
      const chairCount = this.getSelectedChairCount();
      this.syncChairQuantity(combo);
      this.currentCombo = combo;
      let price = combo?.combo?.pricePromo ?? combo?.combo?.priceDefault ?? null;
      price_2 = price
      this.updateCoriguard(combo);

      // Add coriguard price to total if checkbox is checked
      if (this.els.coriguardCheckbox?.checked && this.state.coriguardPrice != null) {
        const coriguardPrice = typeof this.state.coriguardPrice === 'number' 
          ? this.state.coriguardPrice 
          : Number(this.state.coriguardPrice);
        if (Number.isFinite(coriguardPrice) && price != null) {
          price = price + (coriguardPrice * chairCount) ;
        }
      }

      if (this.els.price) {
        this.els.price.textContent = price != null ? formatMoney(price, this.currency) : formatMoney(0, this.currency);
      }
      if (this.els.addtoCartPrice?.length) {
        this.els.addtoCartPrice.forEach(el => {
          el.textContent = price != null
            ? `-${formatMoney(price, this.currency)}`
            : formatMoney(0, this.currency);
        });
      }
      // if (this.els.addtoCartPrice) {
      //   this.els.addtoCartPrice.textContent = price != null ? `-${formatMoney(price, this.currency)}` : formatMoney(0, this.currency);
      // }
      if (this.els.installment && this.els.installmentsWrapper) {
        if (price) {
          this.els.installment.setAttribute('data-price', price);
          const installment = price / 6;
          this.els.installment.textContent = formatMoney(installment, this.currency);
          this.els.price_emi.textContent = formatMoney(installment, this.currency);
          this.els.installmentsWrapper.hidden = false;
        } else {
          this.els.installmentsWrapper.hidden = true;
        }
      }
      this.updateAddToCartState();
      this.updateViewer(combo);
    }

    updateViewer(combo) {
      if (!this.els.viewer) return;
      if (!combo || !combo.combo.cylindoProductCode) {
        this.resetViewer();
        return;
      }

      const accountId = this.cylindoCustomerId || DEFAULT_CYLINDO_ACCOUNT_ID;
      const { cylindoProductCode, features: comboFeatures, cylindoFeaturesJson } = combo.combo;
      const effectiveFeatures = comboFeatures && Object.keys(comboFeatures).length
        ? comboFeatures
        : normaliseCylindoFeatureMap(cylindoFeaturesJson);
      if (effectiveFeatures && (!comboFeatures || comboFeatures !== effectiveFeatures)) {
        combo.combo.features = effectiveFeatures;
      }

      const previewUrl = buildCylindoFrameUrl(
        accountId,
        cylindoProductCode,
        1,
        effectiveFeatures,
        { size: 768, format: 'webp' }
      );

      if (previewUrl) {
        this.previewContext = {
          accountId,
          productCode: cylindoProductCode,
          features: effectiveFeatures,
          size: 768,
          format: 'webp'
        };
        this.previewFrame = 1;
        this.pendingViewerFrame = combo?.requestedFrame ? parseInt(combo.requestedFrame, 10) || 1 : null;
        this.els.viewer.setAttribute('data-viewer-ready', 'image');
        const figure = createElement('figure', { className: 'table-chair-configurator__viewer-figure' });
        const img = createElement('img', {
          className: 'table-chair-configurator__viewer-image',
          attrs: {
            src: previewUrl,
            alt: `${combo.table.rangeDisplay} with ${combo.chair.rangeDisplay} chairs`,
            loading: 'lazy'
          }
        });
        figure.appendChild(img);
        this.els.viewer.innerHTML = '';
        this.els.viewer.appendChild(figure);
        this.previewImage = img;
        if (this.pendingViewerFrame && this.pendingViewerFrame !== 1) {
          this.setPreviewFrame(this.pendingViewerFrame);
        }
      } else {
        this.els.viewer.setAttribute('data-viewer-ready', 'loading');
        this.els.viewer.innerHTML = '<div class="table-chair-configurator__viewer-placeholder">Loading preview…</div>';
        this.previewImage = null;
        this.previewContext = null;
        this.previewFrame = null;
        this.pendingViewerFrame = null;
      }

      loadCylindoModule()
        .then(() => {
          this.renderCylindoViewer(combo);
        })
        .catch(error => {
          console.warn('[Configurator] Cylindo module failed to load', error);
          if (this.els.viewer) {
            if (this.els.viewer.getAttribute('data-viewer-ready') !== 'image') {
              this.els.viewer.setAttribute('data-viewer-ready', 'error');
              this.els.viewer.innerHTML = '<div class="table-chair-configurator__viewer-placeholder">Preview unavailable.</div>';
            } else {
              this.els.viewer.setAttribute('data-viewer-ready', 'image-error');
            }
          }
        });
    }

    resetViewer() {
      if (!this.els.viewer) return;
      this.removeViewerListeners();
      if (this.viewerInstance) {
        try {
          if (typeof this.viewerInstance.disconnect === 'function') {
            this.viewerInstance.disconnect();
          } else if (typeof this.viewerInstance.destroy === 'function') {
            this.viewerInstance.destroy();
          }
        } catch (error) {
          console.warn('[Configurator] Cylindo viewer cleanup failed', error);
        }
      }
      this.viewerInstance = null;
      this.els.viewer.setAttribute('data-viewer-ready', 'false');
      this.els.viewer.innerHTML = '<div class="table-chair-configurator__viewer-placeholder">Select options to preview.</div>';
    }

    removeViewerListeners() {
      if (!Array.isArray(this.viewerListeners)) return;
      this.viewerListeners.forEach(({ element, type, handler }) => {
        try {
          element?.removeEventListener?.(type, handler);
        } catch (error) {
          /* noop */
        }
      });
      this.viewerListeners = [];
    }

    setPreviewFrame(frameNumber) {
      if (!this.previewImage || !this.previewContext) return;
      if (!Number.isFinite(frameNumber) || frameNumber <= 0) return;
      if (this.previewFrame === frameNumber) return;
      const url = buildCylindoFrameUrl(
        this.previewContext.accountId,
        this.previewContext.productCode,
        frameNumber,
        this.previewContext.features,
        {
          size: this.previewContext.size ?? DEFAULT_FRAME_IMAGE_SIZE,
          format: this.previewContext.format ?? 'webp'
        }
      );
      if (url) {
        this.previewImage.src = url;
        this.previewFrame = frameNumber;
      }
    }

    bindViewerEvents(viewerElement) {
      if (!viewerElement) return;
      this.removeViewerListeners();
      const addListener = (type, handler) => {
        viewerElement.addEventListener(type, handler);
        this.viewerListeners.push({ element: viewerElement, type, handler });
      };
      const resolveFrame = detail => {
        if (!detail) return null;
        const candidates = [
          detail.frame,
          detail.index,
          detail.viewerItem?.frame,
          detail.viewerItem?.index,
          detail.viewerItemIndex,
          detail?.item?.frame
        ];
        for (const value of candidates) {
          const num = parseInt(value, 10);
          if (Number.isFinite(num) && num > 0) {
            return num;
          }
        }
        return null;
      };
      addListener('item-change', event => {
        const frame = resolveFrame(event?.detail);
        if (Number.isFinite(frame)) {
          this.setPreviewFrame(frame);
        }
      });
      addListener('frame-change', event => {
        const frame = resolveFrame(event?.detail);
        if (Number.isFinite(frame)) {
          this.setPreviewFrame(frame);
        }
      });
      addListener('features-change', event => {
        const features = normaliseCylindoFeatureMap(event?.detail);
        if (features && this.previewContext) {
          this.previewContext.features = features;
        }
      });
    }

    renderCylindoViewer(combo) {
      if (!this.els.viewer) return;
      if (!window?.customElements?.get || !window.customElements.get('cylindo-viewer')) {
        this.els.viewer.setAttribute('data-viewer-ready', 'error');
        this.els.viewer.innerHTML = '<div class="table-chair-configurator__viewer-placeholder">Preview unavailable.</div>';
        return;
      }

      try {
        const { cylindoProductCode, features: comboFeatures, cylindoFeaturesJson } = combo.combo;
        const featuresMap = comboFeatures && Object.keys(comboFeatures).length
          ? comboFeatures
          : normaliseCylindoFeatureMap(cylindoFeaturesJson);
        const featureEntries = featuresMap ? Object.entries(featuresMap) : [];
        let featureObject = null;

        const viewerElement = document.createElement('cylindo-viewer');
        const viewerCustomerId = this.cylindoCustomerId || '6913';
        const remoteConfigCode = combo?.combo?.remoteConfig || this.cylindoRemoteConfig;
        this.viewerPosition = this.viewerPosition || 'OPEN';
        viewerElement.setAttribute('customer-id', viewerCustomerId);
        viewerElement.setAttribute('code', cylindoProductCode);
        viewerElement.setAttribute('controls', 'fullscreen nav zoom indicators');
        viewerElement.setAttribute('ignore-unknown-features', '');
        viewerElement.setAttribute('data-position', this.viewerPosition);
        if (remoteConfigCode) {
          viewerElement.setAttribute('remote-config', remoteConfigCode);
        }
        viewerElement.style.width = '100%';
        viewerElement.style.height = '100%';
        viewerElement.style.display = 'block';

        if (featureEntries.length) {
          featureObject = Object.fromEntries(featureEntries);
          const featurePairs = featureEntries.map(([key, value]) => `${key}:${value}`);
          const featuresJson = JSON.stringify(featureObject);
          viewerElement.setAttribute('features', featurePairs.join('|'));
          viewerElement.dataset.features = featuresJson;
          const assignFeatures = () => {
            try {
              viewerElement.features = featureObject;
            } catch (error) {
              /* noop */
            }
            if (typeof viewerElement.setFeatures === 'function') {
              try {
                viewerElement.setFeatures(featurePairs);
              } catch (error) {
                /* noop */
              }
            }
            if (typeof viewerElement.updateFeatures === 'function') {
              try {
                viewerElement.updateFeatures(featureObject);
              } catch (error) {
                /* noop */
              }
            }
          };
          assignFeatures();
          requestAnimationFrame(assignFeatures);
          viewerElement.addEventListener('ready', assignFeatures, { once: true });
          viewerElement.addEventListener('viewer-ready', assignFeatures, { once: true });

          const integration = document.createElement('cylindo-shopify-integration');
          const variantId = combo.table.variantId || combo.chair.variantId || String(Date.now());
          integration.setAttribute('features-by-variant-id', JSON.stringify({
            [variantId]: featureObject
          }));
          integration.setAttribute('default-variant-id', variantId);
          viewerElement.appendChild(integration);
        }

        const thumbnailBar = document.createElement('cylindo-thumbnail-bar');
        viewerElement.appendChild(thumbnailBar);

        const frameSource =
          combo?.combo?.thumbnailFrames ??
          combo?.table?.thumbnailFrames ??
          this.thumbnailFrames;
        const desiredFrames = parseFrameList(frameSource);
        if (desiredFrames.length) {
          const cylindo360 = document.createElement('cylindo-360');
          cylindo360.setAttribute('frame', String(desiredFrames[0]));
          viewerElement.appendChild(cylindo360);
          desiredFrames.forEach(frameIndex => {
            const frameEl = document.createElement('cylindo-360-frame');
            frameEl.setAttribute('frame', String(frameIndex));
            viewerElement.appendChild(frameEl);
          });
        }

        desiredFrames.forEach(frameIndex => {
          const thumbnail = document.createElement('cylindo-thumbnail');
          thumbnail.setAttribute('type', 'frame');
          thumbnail.setAttribute('frame', String(frameIndex));
          thumbnail.setAttribute('slot', 'thumbnails');
          viewerElement.appendChild(thumbnail);
        });

        this.els.viewer.innerHTML = '';
        this.els.viewer.appendChild(viewerElement);
        this.els.viewer.setAttribute('data-viewer-ready', 'true');
        this.viewerInstance = viewerElement;
        this.bindViewerEvents(viewerElement);
        if (this.pendingViewerFrame && this.pendingViewerFrame !== this.previewFrame) {
          const targetFrame = this.pendingViewerFrame;
          this.pendingViewerFrame = null;
          this.setPreviewFrame(targetFrame);
          try {
            viewerElement.setAttribute('frame', String(targetFrame));
          } catch (error) {
            /* noop */
          }
          if (typeof viewerElement.setFrame === 'function') {
            try {
              viewerElement.setFrame(targetFrame);
            } catch (error) {
              /* noop */
            }
          }
        } else {
          this.pendingViewerFrame = null;
        }
      } catch (error) {
        console.warn('[Configurator] Cylindo viewer render failed', error);
        this.els.viewer.setAttribute('data-viewer-ready', 'error');
        this.els.viewer.innerHTML = '<div class="table-chair-configurator__viewer-placeholder">Preview unavailable.</div>';
      }
    }
    updateAddToCartState() {
      if (!this.els.addToCart) return;

      const tableVariantId = this.getSelectedTableVariantId();
      const chairVariantId = this.getSelectedChairVariantId();
      const chairQuantity = this.getChairQuantity(this.currentCombo || this.findMatchingCombo());
      const quantityValid = Number.isFinite(chairQuantity) && chairQuantity > 0;

      let disabledReason = '';

      if (!tableVariantId) {
        disabledReason = 'Select a table option that is available online.';
      } else if (!chairVariantId) {
        disabledReason = 'Select a chair option that is available online.';
      } else if (!quantityValid) {
        disabledReason = 'Set a chair quantity greater than zero.';
      } else if (this.isSubmitting) {
        disabledReason = 'Adding your configuration to the cart…';
      }

      const ready = Boolean(tableVariantId && chairVariantId && quantityValid);
      const isDisabled = !ready || this.isSubmitting;

      // Loop all buttons
      this.els.addToCart.forEach((btn) => {
        btn.disabled = isDisabled;

        if (isDisabled && disabledReason) {
          btn.setAttribute('data-disabled-reason', disabledReason);
        } else {
          btn.removeAttribute('data-disabled-reason');
        }
      });

      // status logic
      if (isDisabled && disabledReason && this.canShowDisabledHint()) {
        this.setStatus(disabledReason, 'hint');
        this.resetStatus();
      } else if (!isDisabled && this.els.status && this.els.status.dataset.state === 'hint') {
        this.setStatus('', 'info');
      }
    }

    // updateAddToCartState() {
    //   console.log('sasASas ',this.els.addToCart)
    //   if (!this.els.addToCart) return;
    //   const tableVariantId = this.getSelectedTableVariantId();
    //   const chairVariantId = this.getSelectedChairVariantId();
    //   const chairQuantity = this.getChairQuantity(this.currentCombo || this.findMatchingCombo());
    //   const quantityValid = Number.isFinite(chairQuantity) && chairQuantity > 0;

    //   let disabledReason = '';
    //   if (!tableVariantId) {
    //     disabledReason = 'Select a table option that is available online.';
    //   } else if (!chairVariantId) {
    //     disabledReason = 'Select a chair option that is available online.';
    //   } else if (!quantityValid) {
    //     disabledReason = 'Set a chair quantity greater than zero.';
    //   } else if (this.isSubmitting) {
    //     disabledReason = 'Adding your configuration to the cart…';
    //   }

    //   this.els.addToCart.textContent="dssfsdfsdfsdf"

    //   const ready = Boolean(tableVariantId && chairVariantId && quantityValid);
    //   const isDisabled = !ready || this.isSubmitting;
    //   this.els.addToCart.disabled = isDisabled;
    //   console.log('this.els.addToCart',this.els.addToCart)
    //   if (isDisabled && disabledReason) {
    //     this.els.addToCart.setAttribute('data-disabled-reason', disabledReason);
    //   } else {
    //     this.els.addToCart.removeAttribute('data-disabled-reason');
    //   }
    //   if (isDisabled && disabledReason && this.canShowDisabledHint()) {
    //     this.setStatus(disabledReason, 'hint');
    //     this.resetStatus()
    //   } else if (!isDisabled && this.els.status && this.els.status.dataset.state === 'hint') {
    //     this.setStatus('', 'info');
    //   }

    // }
    // async handleAddToCart() {
    //   const tableVariantId = this.getSelectedTableVariantId();
    //   const chairVariantId = this.getSelectedChairVariantId();
    //   const combo = this.currentCombo || this.findMatchingCombo();
    //   const chairQuantity = this.getChairQuantity(combo);
    //   this.els.addToCart.classList.add('is-loading');
    //   if (!tableVariantId || !chairVariantId) {
    //     this.setStatus('Please complete your configuration first.', 'error');
    //      this.els.addToCart.classList.remove('is-loading');
    //     this.resetStatus()
    //     return;
    //   }
    //   if (!chairQuantity || chairQuantity <= 0) {
    //     this.setStatus('Chair quantity unavailable for the selected configuration. Please try another option.', 'error');
    //      this.els.addToCart.classList.remove('is-loading');
    //     this.resetStatus()
    //     return;
    //   }
    //   if (!await this.checkProductQuantity(tableVariantId, chairVariantId, chairQuantity)) {
    //     this.setStatus('Chair quantity unavailable for the selected configuration. Please try another option.', 'error');
    //      this.els.addToCart.classList.remove('is-loading');
    //     this.resetStatus()
    //     return;
    //   }

    //   const payload = {
    //     items: [
    //       {
    //         id: String(tableVariantId),
    //         quantity: 1,
    //         properties: {}
    //       },
    //       {
    //         id: String(chairVariantId),
    //         quantity: chairQuantity,
    //         properties: {}
    //       }
    //     ]
    //   };

    //   const coriguardVariantId = combo?.chair?.coriguardVariantId || null;
    //   const coriguardPriceRaw = combo?.chair?.priceCoriguard ?? combo?.combo?.priceCoriguard ?? null;
    //   const coriguardPrice = typeof coriguardPriceRaw === 'number' ? coriguardPriceRaw : Number(coriguardPriceRaw);
    //   const hasCoriguardOption = Boolean(
    //     coriguardVariantId &&
    //     coriguardPriceRaw != null &&
    //     Number.isFinite(coriguardPrice)
    //   );
    //   const isCoriguardChecked = Boolean(hasCoriguardOption && this.els.coriguardCheckbox?.checked);

    //   if (hasCoriguardOption) {
    //     const chairItem = payload.items[1];
    //     chairItem.properties = {
    //       ...chairItem.properties,
    //       CoriguardProduct: String(coriguardVariantId),
    //       _CoriguardProductPrice: String(coriguardPriceRaw ?? coriguardPrice),
    //       _isParent: isCoriguardChecked ? 'true' : ' '
    //     };
    //     if (isCoriguardChecked) {
    //       payload.items.push({
    //         id: String(coriguardVariantId),
    //         quantity: chairQuantity,
    //         parent_id: String(chairVariantId),
    //         properties: {
    //           CoriguardProduct: String(chairVariantId),
    //           _isCoriguardProduct: 'true'
    //         }
    //       });
    //     }
    //     this.state.coriguardSelected = isCoriguardChecked;
    //   }

    //   if (typeof console !== 'undefined') {
    //      this.els.addToCart.classList.remove('is-loading');
    //     try {
    //       console.log('[Configurator] Cart payload items:', payload.items);
    //     } catch (error) {
    //        this.els.addToCart.classList.remove('is-loading');
    //       /* noop */
    //     }
    //   }

    //   this.isSubmitting = true;
    //   this.updateAddToCartState();
    //   this.setStatus('Adding to cart…', 'info');
    //   //this.els.addToCart.classList.add('is-loading');

    //   try {
    //     const response = await fetch('/cart/add.js', {
    //       method: 'POST',
    //       headers: {
    //         'Content-Type': 'application/json',
    //         'Accept': 'application/json'
    //       },
    //       body: JSON.stringify(payload)
    //     });
    //     if (!response.ok) {
    //       const error = await response.json().catch(() => ({ description: 'Unable to add to cart.' }));
    //       throw new Error(error.description || 'Unable to add to cart.');
    //     }
    //     this.setStatus('Added to cart! View your basket to checkout.', 'success');
    //     this.root.dispatchEvent(new CustomEvent('configurator:addToCart', {
    //       detail: {
    //         payload,
    //         combo: this.currentCombo
    //       }
    //     }));
    //     await this.openSideCart();
    //   } catch (error) {
    //     console.error('[Configurator] Add to cart failed', error);
    //     this.setStatus(error.message || 'Unable to add to cart.', 'error');
    //   } finally {
    //     this.isSubmitting = false;
    //     this.els.addToCart.classList.remove('is-loading');
    //     this.resetStatus()
    //     this.updateAddToCartState();
    //   }
    // }
    async handleAddToCart() {
      const tableVariantId = this.getSelectedTableVariantId();
      const chairVariantId = this.getSelectedChairVariantId();
      const combo = this.currentCombo || this.findMatchingCombo();
      const chairQuantity = this.getChairQuantity(combo);

      // 🔥 Apply loading state to ALL buttons
      this.els.addToCart.forEach(btn => btn.classList.add('is-loading'));

      if (!tableVariantId || !chairVariantId) {
        this.setStatus('Please complete your configuration first.', 'error');
        this.els.addToCart.forEach(btn => btn.classList.remove('is-loading'));
        this.resetStatus();
        return;
      }

      if (!chairQuantity || chairQuantity <= 0) {
        this.setStatus('Chair quantity unavailable for the selected configuration. Please try another option.', 'error');
        this.els.addToCart.forEach(btn => btn.classList.remove('is-loading'));
        this.resetStatus();
        return;
      }

      if (!await this.checkProductQuantity(tableVariantId, chairVariantId, chairQuantity)) {
        this.setStatus('Chair quantity unavailable for the selected configuration. Please try another option.', 'error');
        this.els.addToCart.forEach(btn => btn.classList.remove('is-loading'));
        this.resetStatus();
        return;
      }

      const payload = {
        items: [
          { id: String(tableVariantId), quantity: 1, properties: {} },
          { id: String(chairVariantId), quantity: chairQuantity, properties: {} }
        ]
      };

      const coriguardVariantId = combo?.chair?.coriguardVariantId || null;
      const coriguardPriceRaw = combo?.chair?.priceCoriguard ?? combo?.combo?.priceCoriguard ?? null;
      const coriguardPrice = typeof coriguardPriceRaw === 'number' ? coriguardPriceRaw : Number(coriguardPriceRaw);
      const hasCoriguardOption = Boolean(
        coriguardVariantId &&
        coriguardPriceRaw != null &&
        Number.isFinite(coriguardPrice)
      );
      const isCoriguardChecked = Boolean(hasCoriguardOption && this.els.coriguardCheckbox?.checked);

      if (hasCoriguardOption) {
        const chairItem = payload.items[1];
        // Get the formatted price from the display element
        const coriguardPriceDisplay = this.els.coriguardPrice?.textContent?.trim() || '';
        chairItem.properties = {
          ...chairItem.properties,
          CoriguardProduct: String(coriguardVariantId),
          _CoriguardProduct_Price: coriguardPriceDisplay,
          _isParent: isCoriguardChecked ? 'true' : ''
        };

        if (isCoriguardChecked) {
          payload.items.push({
            id: String(coriguardVariantId),
            quantity: chairQuantity,
            parent_id: String(chairVariantId),
            properties: {
              CoriguardProduct: String(chairVariantId),
              _isCoriguardProduct: 'true'
            }
          });
        }

        this.state.coriguardSelected = isCoriguardChecked;
      }

      this.isSubmitting = true;
      this.updateAddToCartState();
      this.setStatus('Adding to cart…', 'info');

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(payload)
        });

        if (!response.ok) {
          const error = await response.json().catch(() => ({ description: 'Unable to add to cart.' }));
          throw new Error(error.description || 'Unable to add to cart.');
        }

        this.setStatus('Added to cart! View your basket to checkout.', 'success');

        this.root.dispatchEvent(new CustomEvent('configurator:addToCart', {
          detail: { payload, combo: this.currentCombo }
        }));

        await this.openSideCart();

      } catch (error) {
        console.error('[Configurator] Add to cart failed', error);
        this.setStatus(error.message || 'Unable to add to cart.', 'error');

      } finally {
        this.isSubmitting = false;
        this.els.addToCart.forEach(btn => btn.classList.remove('is-loading'));
        this.resetStatus();
        this.updateAddToCartState();
      }
    }

    async openSideCart() {
      const body = typeof document !== 'undefined' ? document.body : null;
      const updateSidebar = cart => {
        let handled = false;
        if (cart && window?.halo?.updateSidebarCart) {
          try {
            window.halo.updateSidebarCart(cart);
            handled = true;
          } catch (error) {
            console.warn('[Configurator] Unable to update sidebar cart', error);
          }
        }
        if (!handled && cart && window?.sharedFunctions?.updateSidebarCart) {
          try {
            window.sharedFunctions.updateSidebarCart(cart);
            handled = true;
          } catch (error) {
            console.warn('[Configurator] Unable to update sidebar cart via sharedFunctions', error);
          }
        }
        if (body) {
          body.classList.add('cart-sidebar-show');
        }
      };

      try {
        const rootUrl = window?.Shopify?.routes?.root || '/';
        const response = await fetch(`${rootUrl}cart.js`, {
          method: 'GET',
          headers: {
            'Accept': 'application/json'
          },
          credentials: 'same-origin',
          cache: 'no-cache'
        });
        if (response.ok) {
          const cart = await response.json();
          updateSidebar(cart);
          return;
        }
      } catch (error) {
        console.warn('[Configurator] Unable to retrieve cart for sidebar', error);
      }

      updateSidebar(null);
    }

    canShowDisabledHint() {
      if (!this.els.status) return false;
      const state = this.els.status.dataset.state;
      const message = this.els.status.textContent?.trim();
      return !message || !state || state === 'info' || state === 'hint';
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const roots = document.querySelectorAll('[data-configurator]');
    roots.forEach(root => new TableChairConfigurator(root));
  });
})();



$(document).ready(function () {
  const $configurator = $('.custom-table-chair-configurator__groups');

  // Hide all bodies initially
  $configurator.find('.config-group__body').hide();

  // Click event only inside this configurator
  $configurator.on('click', '.config-group__header', function () {
    const $body = $(this).next('.config-group__body');

    // Close others inside the same configurator
    $configurator.find('.config-group__body').not($body).slideUp();

    // Toggle the clicked one
    $body.slideToggle();
  });
});
